import React, { useState, useEffect, useRef } from "react";
import {
  CalendarMonthOutlined,
  CheckOutlined,
  EditOffOutlined,
  EditOutlined,
  Logout,
  SearchOutlined,
} from "@mui/icons-material";
import { RadioButton } from "primereact/radiobutton";
import {
  Grid,
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  Link,
  Typography,
  Skeleton,
  collapseClasses,
  Checkbox,
  Autocomplete,
  FormLabel,
  CircularProgress,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper
} from "@mui/material";
import TextareaAutosize from '@mui/material/TextareaAutosize';
import MuiInput from "../../elements/Mui/mui_input";
import MuiTextArea from "../../elements/Mui/Mui_TextArea";
import MuiAutocomplete from "../../elements/Mui/mui_Autocomplete";
import MuiDatePicker from "../../elements/Mui/mui_date_picker";
import MuiSearchBar from "../../elements/Mui/mui_searchbar";
import MuiButton from "../../elements/Mui/mui_button";

import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import "../../styles/addmember.css";
import "../../styles/brandingStyles/branding.css";
import signupBanner from "../../assets/userAccount/signupBanner.png";
import {
  PersonOutline,
  LockOutlined,
  VisibilityOutlined,
  VisibilityOffOutlined,
  LoginOutlined,
  AlternateEmailOutlined,
  PhoneIphoneOutlined,
} from "@mui/icons-material";
import axios from "axios";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { LinkHeader } from "../../components/linkHeader";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import { Calendar } from "primereact/calendar";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useMediaQuery } from "react-responsive";
import CustomAxios from "../../utils/CustomAxios";
import EditNoteIcon from "@mui/icons-material/EditNote";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { DataTable } from "primereact/datatable";
import AddIcon from "@mui/icons-material/Add";
import { Column } from "jspdf-autotable";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import CloseIcon from "@mui/icons-material/Close";
import { Transactions } from "../transactions";
import { MemberTransaction } from "./memberTransaction";
import { useDispatch, useSelector } from "react-redux";
import { updateDates, updateKeyIn, updateMemberid } from "../../redux/toggleBarReducer";
import AccountCircleTwoToneIcon from "@mui/icons-material/AccountCircleTwoTone";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import { InputSwitch } from "primereact/inputswitch";
import { Dialog } from "primereact/dialog";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import { updateMemberListPayload } from "../../redux/executiveReducer";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import "primereact/resources/themes/saga-blue/theme.css"; 
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import dayjs from "dayjs";
import { useTheme } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Fade from '@mui/material/Fade';
import DeleteIcon from '@mui/icons-material/Delete';

export function Signup() {

  const theme = useTheme();

  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("Oasis@1234");
  const [memberId, setMemberId] = useState("");
  const memberid = useSelector((state) => state.toggleBar.memberid);
  const [oasisId, setOasisId] = useState("");
  const [signupmessage, setSignupMessage] = useState("");
  const [dob, setDob] = useState(null);
  const [doj, setDoj] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [memberName, setMemberName] = useState("");
  const [memberEmail, setMemberEmail] = useState("");
  const [toggle, setToggle] = useState("Member Profile");
  let transType = "share_transactions";
  let seltrans = useSelector((state) => state.toggleBar.trans)
  transType = seltrans==""?"share_transactions":seltrans;
  const loansel = useSelector((state) => state.toggleBar.loansel);
  const dates = useSelector((state)=>state.toggleBar.dates);
  ////console.log(transType);
  const [recordtype, setRecordType] = useState("");
  const [checked, setChecked] = useState(false);
  const [selected, setSelected] = useState([]);
  const [oldNric, setOldNric] = useState("");
  const [newNric, setNewNric] = useState("");
  const [tinNo, setTinNo] = useState("");
  const [adress1, setAdress1] = useState("");
  const [adress2, setAdress2] = useState("");
  const [adress3, setAdress3] = useState("");
  const [adress4, setAdress4] = useState(null);
  const [corradress1, setCorrAdress1] = useState("");
  const [corradress2, setCorrAdress2] = useState("");
  const [corradress3, setCorrAdress3] = useState("");
  const [corradress4, setCorrAdress4] = useState("");
  const [postal, setPostal] = useState("");
  const [officeTel, setOfficeTel] = useState("");
  const [houseTel, setHouseTel] = useState("");
  const [hpNo, setHpNo] = useState("");
  const [hpWpNo, setHpWpNo] = useState("");
  const [sex, setSex] = useState(null);
  const [race, setRace] = useState(null);
  const [occupation, setOccupation] = useState(null);
  const [accNo, setAccNo] = useState("");
  const [state, setState] = useState("");
  const [estate, setEstate] = useState(null);
  const [notes, setNotes] = useState(null);
  const [mykad, setMykad] = useState(false);
  const [nomform, setNomForm] = useState(false);
  const [nommykad, setNomMykad] = useState(false);
  const [deathcert, setDeathCert] = useState(false);
  const [pstatus, setPstatus] = useState(false);
  const [nomailer, setNomailer] = useState(false);
  // const [deceased, setDeceased] = useState(false);
  const [dispaction, setDispAction] = useState(false);
  const [director, setDirector] = useState(false);
  const [observer, setObserver] = useState(false);
  const [delegate, setDelegate] = useState(false);
  const [company, setCompany] = useState(false);
  const [nonbenifit, setNonBenefit] = useState(false);
  // const [terminated, setTerminated] = useState(false);
  const [entryFee, setEntryFee] = useState(false);
  const [delegatesince, setDelegateSince] = useState(dayjs());
  const [nomName, setNomName] = useState("");
  const [age, setAge] = useState("");
  const [nomineeage, setNomineeAge] = useState("");
  const [nomicno, setNomicno] = useState("");
  const [relationship, setRelationship] = useState("");
  const [percentshare, setPercentshare] = useState("");
  const [membershipNo, setMembershipNo] = useState();
  const [nomineeresponse, setNomineeresponse] = useState();
  const [nomineeModel, setNomineeModel] = useState(false);
  const [nomineeModelType, setNomineeModelType] = useState("");
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [membererror, setMembererror] = useState("");
  const [emailerror, setEmailerror] = useState("");
  const [passworderror, setPassworderror] = useState("");
  const [doberror, setDobError] = useState("");
  const [dojerror, setDojError] = useState("");
  const [deceasederror, setDeceasedError] = useState("");
  const [terminatederror, setTerminatedError] = useState("");
  const [delegateSinceError, setDelegateSinceError] = useState("");
  const [nricerror, setNricError] = useState("");
  const [mykadDateError, setMykadDateError] = useState("");
  const [nomnamerror, setNomNameError] = useState("");
  const [nomicerror, setNomIcError] = useState("");
  const [imagefile, setImagefile] = useState("");
  const [relError, setRelError] = useState("");
  const [perError, setPerError] = useState("");
  const [nomineeError, setNomineeError] = useState("");
  const [estateError, setEstateError] = useState("");

  const [response, setResponse] = useState();
  const [memberNo, setMemberNo] = useState("");
  const [searchMember, setSearchMember] = useState("");
  const [searchMemberStatus, setSearchMemberStatus] = useState(false);
  const [editdetails, setEditDetails] = useState(false);
  const [imageStatus, setImageStatus] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [memberSuccess, setMemberSuccess] = useState();
  const [corresSuccess, setCorresSuccess] = useState(false);
  const [corresDeleted, setCorresDeleted] = useState(false);
  const [bank, setBank] = useState(null);
  const [corrdel, setCorrDel] = useState(false);
  const [banks, setBanks] = useState([]);
  const [nomineeCount, setNomineeCount] = useState(1);
  const [states, setStates] = useState([]);
  const [memberNric, setMemberNric] = useState([]);
  const [printmlModel, setPrintmlModel] = useState(false);
  // const [nricDuplicate,setNricDuplicate]=useState([])
  const [estatesArray, setEstatesArray] = useState([]);
  const [searchbulkdialogopen, setSearchBulkDialogopen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [estateList, setEsatateList] = useState([]);
  const [nomineeList, setNomineeList] = useState([]);
  const [terminateddate, setTerminateddate] = useState(null);
  const [deceaseddate, setDeceaseddate] = useState(null);
  const [active, setActive] = useState("Member Profile");
  const [corressAddressError, setcorressAddressError] = useState("");
  const [occupationArray, setOccupationArray] = useState([]);

  const [tableLoader, setTableLoader] = useState(false);
  const [snackbarArray, setSnackbarArray] = useState({msg:'', color: ''})

  const memberList = useSelector((state) => state.executive.memberLists);
  let translist = ['share_transactions', 'subscription_transactions', 'loan_transactions']
  const [inputs, setInputs] = useState([
    // {
    //   nomineename: "",
    //   nomineeicno: "",
    //   relationship: "",
    //   percentage: "",
    //   age: "",
    // },
  ]);
  const today = new Date();
  const [filteredMemberList, setFilteredMemberlist] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState('memberid'); // To store the selected filter option
  const [columnFilteredMemberList, setColumnFilteredMemberlist] = useState([]);
  const [columnFilters, setColumnFilters] = useState({
    memberid: '',
    membername: '',
    estate: '',
    state: '',
    newicno: '',
    oldicno: ''
  });

  // console.log("filteredMeber list************", filteredMemberList)
  //const [memberDetailsDialogOpen, setMemberDetailsDialogOpen] = React.useState(false);
  // const [memberDetails, setMemberDetails] = React.useState(null); // State to hold member details
  const formRef = useRef(null);
  // const states = ["ALL","CIL", "JHR", "KDH", "KLN", "MLK", "NSL", "PHG", "PLS", "PPG", "PRK", "SEL", "TUN", "WPK"]
  // const estates = ["LADANG SUNGAI WANGI", "LADANG BERTAM,BHG PARIT MELANA", "LADANG SG TEKAL", "SANHERLI FURNITURE INDUSTRIE", "MLK - M. SUBRAMANIAM", "LADANG GLUGOR", "LADANG TORKINGTON", "LDG ATHERTON SG SALAK  DIV", "LADANG BEE YONG", "LADANG SG ULAR", "MLK - NAGARAJU", "PARAMASIVAM - ARUMUGAM CHINASWAMY", "ANGKASA", "LADANG BERTAM,BERTAM DIVISION", "KSEL - MUTHAMIZIE ARUMUGAM", "LADANG CHIPOK", "LADANG BIKAM", "LADANG ENG WAH", "LADANG LAPAN UTAN", "PARAMASIVAM - KRISNAVANI MURUGAN", "PARAMASIVAM - PARVATHY KASI", "LADANG SEMANTAN", "LADANG CHENG THENG", "LADANG BUKIT SELARONG", "LADANG WEST,7", "LADANG SG SENARUT", "LADANG BUKIT TALANG", "LADANG ST. HELIER", "MLK - M. LOGANATHAN", "LADANG PINANG TUNGGAL", "LADANG NYIOR", "LADANG FLEMINGTON FLEMINGTON DIV.", "VANNILLA - PENGKALAN HULU", "LADANG JERAI, DIVISION 3", "LADANG SG BIONG", "LADANG PERBADANAN KEDAH", "LADANG K.SELANGOR - BKT BELIMBING DI", "LADANG SG TUKANG", "LADANG BUDU", "LAKSHMANAN CONT", "LADANG SG DINGIN BAH 6", "LADANG PAYA KEMUNTING", "MLK - MAGESWARAN P.MUTHU", "KSEL - RAJINTERAN VEMPODY", "LADANG KUALA SELANGOR", "LADANG TANAH MERAH DIV A2", "LADANG LABU CHEVIOT", "LADANG SOGOMANA", "NO MAILER - PLS", "LADANG JERAM PADANG HOME DIV", "LADANG SUNGAI REYLA", "LADANG SAILANG", "LADANG ULU PEDAS", "RAMALINGAM CONT", "LADANG KEMUNING BAHAGIAN KRU", "MLK - C.RAMAKRISHNAN", "LADANG SEPANG, SUNGAI LINAU DIV", "LDG KSKB", "LADANG VICTORIA", "LADANG SALAK", "LADANG DIAMOND JUBILEE", "LADANG BOH,CHEKHO DIV", "LADANG ULU PEDAS BATU HAMPER DIV", "INDIVIDUAL - JHR", "LADANG SG BERANG", "LADANG BUKIT ROTAN", "LADANG JERAM KUANTAN", "LADANG NORTH,DIVISION 2 ", "LDG FLEMINGTON FLEMINGTON DIVISION", "MLK - VENGDA SALAM", "LADANG CLAIRE", "NSL - KANNAN SUBRAMANIAM", "LADANG BOH,SOUTH DIV", "LADANG TEKAU", "LADANG JERAM PADANG KEPIS DIV", "LADANG GLENEALY", "LADANG BIDOR TAHAN", "LADANG KELANANG BARU", "KILANG KELAPA SAWIT RANTAU", "PARAMASIVAM CONT", "LADANG PERHENTIAN TINGGI", "LADANG SG WANGI DIVISION 1", "LADANG ESCOT", "SIME DARBY SEEDS & AGR SERVICES S/B", "LADANG LAMBAK", "LADANG BUKIT SELAMBAU", "VANNILLA - PELAM", "LADANG C.E.P NIYOR", "JAGATIS CONT", "LADANG NEW SEREMBAN", "ANGKASA PHG", "LADANG ENG HONG", "OIL PALM RESEARCH STATION", "MLK - NAGARAJAH RATANAM", "KILANG KELAPA SAWIT EAST (KKS EAST)", "LADANG SG SEDU", "LADANG HUNTLY", "LADANG FLEMINGTON TELUK BULOH DIV.", "LADANG JOHOR LABIL OIL MILL", "LADANG SERAPOH", "LADANG WESSINGTON", "LADANG HOLYROAD", "EMAIL - PPG", "KILANG KELAPA SAWIT SUA BETONG", "LADANG GULA", "LADANG JERAI, DIVISION 2", "OPRS QTC DIV", "INDIVIDUAL - MLK", "LADANG NORTH LABIS", "LADANG TUAN MEE COALFIELDS DIVISION", "NO MAILER - TUN", "RAJELEKSHMI CONT", "NO MAILER - CIL", "LADANG GOLDEN HOPE", "LADANG HILL RISE", "LOKONATHAM - DEVI ARUMUGAM", "LADANG FLEMINGTON NEW COCONUT DIV.", "PARAMASIVAM - MURUGAYAI KANDASAMY", "LADANG SG DINGIN BAH 3", "A.T. BULK TRADING SDN BHD", "LEONG WATT HIN", "LADANG WEST", "LADANG KUALA KANGSAR", "SIME DARBY PLANTATION RESEARCH SDN BHD", "LADANG SURKAM", "NO MAILER - NSL", "SYARIKAT V.M.M", "LADANG LABIS BAHRU", "TROLLI MASTER SDN BHD", "LADANG JENDARATA", "LADANG LIM CHOW CHONG", "LADANG PAYA LANG", "LADANG BATANG MELAKA", "KILANG KELAPA SAWIT WEST (KKS WEST)", "LADANG KILLINGHALL", "SUPARAYAN CONT", "LADANG BERADIN", "LADANG JERAI,DIVISION 1", "LADANG MERLIMAU", "LADANG KUALA KETIL", "EMAIL - SEL", "LADANG SOUTHERN MALAY", "LADANG NOVA SCOTIA", "MLK - S.VARUNI", "RAJELEKSHMI - S. KANNAN", "LADANG KUPANG", "LADANG SILIAU - DIVISION NORTH SOUTH", "LADANG SG PUNTA", "PARAMASIVAM - KANAGAVALLY GANESH", "LADANG TALI AYER - SUNGEI KRIAN DIVISION", "LADANG JIN SENG", "MLK - ULALI CHELEH", "MLK - NALLAIYA PONNUSAMY", "PARAMASIVAM - KALI", "KILANG BATU BATA HAP KEE SDN BHD", "LADANG BROUNSTON", "LADANG JATI", "LADANG SG GERCHANG BAH 2", "PARAMASIVAM - NALANIAMA ANNAMALAI", "LADANG GETAH PEKAN", "LADANG BUKIT RAJA", "LADANG SILIAU", "LADANG EAST", "MLK - UMAH DEVI VEERA PUTHRAN", "LADANG MAJORIE", "INDIVIDUAL BULK - NSL", "PARAMASIVAM - NIRMALA UTHAMAN", "LADANG SHALIMAR", "LADANG TEBRAU", "INDIVIDUAL - KDH", "PARAMASIVAM - VELAN SAHADEWAN", "MLK - MANI ANDEY", "LADANG JOHOR RIVER", "LADANG JOHOR LABIS DIV 1", "RAJELEKSHMI - G. KANNUSAMY", "MLK - M.MARATHAN MUTHU", "ANGKASA SEL", "LADANG CHANGKAT SALAK", "PARAMASIVAM - SUBALAKSHMIE SUBRA", "NO MAILER - PHG", "LADANG SUA BETONG", "LADANG LEE BAKAI", "VANNILLA - BT PEKAKA", "LADANG BAGAN DATOH", "LADANG EAST,SIMPANG LIMA", "LADANG KUALA BERNAM", "LADANG FOOTHILLS", "LADANG SUNGAI BERANANG", "LADANG JUASSEH", "LADANG BUKIT DARAH", "SUBRAMANIAM CONT", "LADANG LOCK LIAN", "LADANG KATUMBA", "LADANG BUNTAR", "LADANG SEPANG ,SEPANG OIL MILL DIV", "EMAIL - PRK", "KAMPUNG BARU DIVISION", "MLK - POOBALAN", "MLK - PRAMILA GOVINDAN", "LADANG ANAK KULIM", "LADANG CRAIGIELEA", "LADANG LEONG WATT HIN", "LADANG SG CHOH", "LADANG BATU LINTANG     43", "LADANG NIGEL GARDENER", "LADANG SG GERCHANG BAH 1", "NO MAILER - PRK", "KSKB STAFF", "LADANG BRADWALL", "LADANG NEWBERRY", "EMAIL - NSL", "LADANG SELINSING", "LADANG BUKIT HITAM", "LADANG SOUTH DIV 7", "VANNILLA - TMN PERMAI JAYA", "LADANG JERAM PADANG", "LADANG SUBUR NORSEMAN DIV", "KUALA SELANGOR GROUP OFF ESTATE", "LADANG GLEANELY REYLAND DIV", "TUAN MEE OIL MILL", "PARAMASIVAM - SHANTI VEMPODY", "INDIVIDUAL - WPK", "LADANG BYRAM", "NO MAILER - WPK", "LADANG PINJI,MERANTI LAPAN DIVISION", "VANNILLA - BALING", "MLK - THAMARAI VEERAPPAN", "LADANG SUNGEI CHINOH", "LADANG YONG PENG", "LADANG UPI", "MLK - S.KANNAN", "LADANG KARMEN", "LADANG GALLOWAY", "KSEL - UTHAMAN VELOO", "LADANG ULU BERNAM", "LADANG KELPIN", "MSIA PREC MANU SDN BHD", "LADANG PINJI", "LADANG MOUNT AUSTIN", "LADANG SENAI", "PARAMASIVAM - PARAMASIVAN KATHAN", "LADANG BUKIT LEMBU", "LADANG BULUH AKAR 1", "LADANG RASAK", "LADANG BUKIT CHERAKAH", "MLK - R.VISWANATHAN", "ANGKASA NSL", "KSEL - TAMILSELVI MUNIANDY", "LADANG GUNONG PULAI", "PARAMASIVAM - PARAMESWARY VELOO", "LADANG EAGLE HURST", "LADANG SG SALAK", "KALAS FLOUR MILLS (M) SDN BHD", "LADANG MONMOUTH", "KSEL - PANNIER SELVAM VELOO", "LADANG SG DINGIN BAH 1", "LADANG BENTA", "LADANG KERLING", "PERUMAL SOCKALINGAM CONT", "LADANG THONG HURST", "LADANG KG KUANTAN", "LADANG SENAMA BAHAU", "LADANG BUKIT ASAHAN", "LADANG ELPHIL", "LADANG SEMBRONG", "LADANG KOMBOK", "LADANG SENAMA CONTRACT WORKERS", "LADANG BUKIT DINDING", "INDIVIDUAL - NSL", "PARAMASIVAM - SANGARALINGAM MUNIANDY", "MLK - KUPPUSAMY SAINASAMY", "ANGKASA JHR", "LADANG NEWTON", "LADANG ULU TIRAM", "KATHARAYAN RAMIAH CONT", "LADANG KAMPAR", "MLK - RAJA VETARAYAN", "LADANG NAM BEE", "MLK - GOPAL SITHAN", "LADANG SOUTH,BANGUNG", "LADANG SG RAYA", "MLK - K.VIMAL", "LADANG LINSUM", "ANGKASA TUNG 2", "GAJABALAN CONT", "LADANG KSKB - MAGEN", "LADANG ATHERTON", "MLK - V PANJAVARNAM", "LADANG JERAI, DIVISION 1", "LADANG KOMBOK MANTIN DIVISION", "ANGKASA TUNG 3", "LADANG MADAR", "LADANG MENGKARAK", "LADANG CHENG", "LADANG LINSUM TERENTANG DIVISION", "LADANG AYER HITAM", "LADANG KMR KLANG LAMA", "LADANG BUKIT CHEEDING", "LADANG LEDANG", "LADANG SG BERNAM", "MLK - SAMINATHAN G", "LDG KUALA KANGSAR SG BIONG DIV", "LADANG TUAN", "PARAMASIVAM - SARALAH PARAMASIVAM", "LADANG BERTAM", "LADANG PADANG SERAI", "LADANG CHELLAM", "MALMAJU BINA SDN BHD", "LADANG SG TINGGI", "RAJESLEKSHMI CONT", "EMAIL - MLK", "PARAMASIVAM - ARMUGAM KANNOO", "LADANG CHENOR", "MLK - VELRAJENDRAN KUPPAN", "LADANG SG BOGAK", "LADANG KARAI NAGAR", "LADANG CLUNY", "MLK - PARVATHY ARUMUGAM", "LADANG KENNY", "ARUMUGAM CONT", "LADANG GLEANELY", "ANGKASA TUNG", "LOKONATHAM - ARUMUGAM SITIRAI", "LADANG SG DINGIN BAH 4", "LADANG PINJI HILLRISE DIV", "LADANG REM", "LADANG GUNUNG KUANG", "LADANG SG BILL", "LADANG GOLCONDA", "MLK - AMAHKANU", "MLK - SELVARANI SHANMUGAM", "LADANG SOUTH,AIR HITAM", "LADANG BUKIT TALANG OIL MILL", "LADANG CEP", "PERSATUAN PEKERJA-PEKERJA INDIA", "LADANG BATU LINTANG", "LADANG MENTAKAB", "LADANG LUNAS", "LADANG TRP", "CHERSONESE OIL MILL", "LADANG BUKIT PANJONG", "LADANG PRANG BESAR", "LADANG RAYCRAFT", "KILANG KELAPA SAWIT GOLCONDA", "KALUMPONG OIL MILL", "PARAMASIVAM - NAGAMAH PERIASAMY", "MLK - S BALAKRISHNAN", "LADANG SG BAHRU", "ELMINA PALM OIL MILL", "ULU BERNAM OIL MILL", "LADANG SELAMA", "LADANG LIEW WENG CHEE", "LADANG SENG GIAP", "LADANG BOH,ULONG DIV", "LADANG KELAN", "LADANG KOMBOK ULU SAWAH DIV", "LADANG SG SEDU,BGH TELOK DATOK", "LADANG TUMBUK", "LADANG KOTA BAHROE GROUP", "LADANG TANJUNG PAU", "MLK  - N.VISVANATHAN", "LADANG ATHERTON SG SALAK  DIV", "NSL - PALANISAMY MALAYAPPAN", "LADANG SUNGAI TEKAL", "LADANG BENTONG", "LADANG LEMBAH KELUANG", "LADANG DUSUN DURIAN", "LADANG PLANG", "LADANG MALAYA", "LADANG JERAM", "LADANG PANJI", "LADANG PADANG MEIHA", "LADANG FLEMINGTON", "LADANG WINDSOR", "LADANG BHUTAN", "LADANG WEST,6", "LADANG BMR", "NO MAILER - PPG", "LADANG SUNGEI GERCHANG", "KILANG GETAH BEDONG", "LADANG SUNGAI KRUDDA", "LADANG KUALA PERAK", "LADANG SIMPANG", "LADANG KAM GARDEN - SUNGKAI", "LADANG BUKIT KELEDEK", "LADANG SWEE LAM", "LADANG SG RAMBAI", "NO MAILER - JHR", "MLK - PARAVATHY SUPPAYAH", "LDG LINSUM TERENTANG DIVISION", "LADANG MIDLANDS", "NO MAILER - KDH", "LADANG CHUAN LENG", "LADANG BMR BARU", "LADANG LANCHANG", "LADANG SUNGAI GETAH", "LADANG PETANI PARA", "LADANG BKT ASAHAN AIR TEKAH DIV", "PERUMAL SOCKALINGAM - K.SELVI", "LADANG SG KAHANG", "LADANG KINTA KELLAS", "ARJUNAN CONT", "LADANG HARCROFT", "LADANG STRATUMASHINE", "LADANG BUKIT PILAH", "LADANG PINJI,SENGAT DIVISION", "LADANG CHAMEK", "LADANG SILIAU SOUTH", "INDIVIDUAL - SEL", "LADANG KEMUNING", "ANGKASA TUNG 4", "PARAMASIVAM - VASANTHI RAJINTERAN", "PARAMASIVAM - PERUMAL AYAPPAN", "LADANG TEBOLANG", "PARAMASIVAM - RAMASAMY SADAYAN", "VANNILLA - NAGAIAH NOOKAIAH", "LADANG NORTH,DIVISION 1", "LADANG AIR HITAM", "LADANG VOULES", "LOKONATHAM - RAJU THANGIAH", "LADANG JASIN LALLANG", "LADANG NEW ROMPIN", "LADANG KERLING SG JERNIH DIVISION", "INDIVIDUAL - PRK", "LADANG PELAM", "SRI GANESH ENTERPRISE SDN BHD", "LADANG KUALA KANGSAR SG BIONG DIV", "KILANG KELAPA SAWIT BATU LINTANG", "LADANG PERTANG", "LADANG KR", "GUTHRIE BIOTECH LABORATORY SDN BHD", "MLK - RETNAVALLI", "LADANG BULUH AKAR 2", "EMAIL - JHR", "MLK - PALANIAMMAH", "LADANG MENGKIBOL", "LADANG BERTAM,BHG DURIAN TUNGGAL", "LADANG TRIANG", "LADANG KOK FOH", "LADANG JERAI,BAHAGIAN 2", "LADANG KAMUNING - PERAK", "MLK - KAVITHA KANNAN", "LADANG BATANG JELAI", "LADANG KEMASUL", "LADANG BERTAM,BHG KRUBONG", "LADANG CHANGKAT ASAH", "LADANG TERONG", "LADANG RENJOK - LIEW WENG CHEE DIV", "KILANG KELAPA SAWIT TENNAMARAM", "LADANG BUKIT JALIL", "LADANG JERAM PADANG GOODWOOD DIV.", "MLK - ARULANANTHAN SANASSIE", "KOK FOH PALM OIL MILL", "EMAIL - KDH", "PARAMASIVAM - GANESH KARPALAVI", "LADANG CHERSONESE", "LADANG CONNEMARY", "LADANG JUGRA", "LADANG KAMIRI", "ANGKASA TUNG 500", "KILANG KELAPA SAWIT JERAM PADANG", "LADANG PADANG BULUH", "INDIVIDUAL - PPG", "LADANG KALUMPONG", "PARAMASIVAM - NIRMALAH RAJINTERAN", "EMAIL - WPK", "KILANG KELAPA SAWIT DIAMOND JUBILEE", "KSEL - RASAMAH KUPPUSAMY", "INDIVIDUAL - PHG", "LADANG TEMEN", "LADANG LUBOK SEGENTAH", "ANGKASA MLK", "LADANG SG. DINGIN", "LADANG SG DINGIN BAH 2", "LADANG TEBONG", "LADANG R.R.I", "PARAMES CONT", "LADANG SABAI", "LADANG BOH,CENTRAL DIV", "PARAMASIVAM - ARUGENAN GEANASAN", "LADANG SG MAI", "GUTHRIE LATEX SILIAU", "LADANG JOHOR LABIS", "LADANG STOTHARD", "LADANG SG BUAYA", "LADANG BATU KAWAN", "NO MAILER - SEL", "LADANG EAST,SG KLUANG", "ANGKASA PRK", "ANJALAY CONT", "LADANG CHEONG WING CHAN SDN BHD", "LADANG BLENHEIM / PERAK RIVER", "SIME DARBY PLANTATION SDN BHD", "KILANG GETAH GUTHRIE", "LADANG SABRANG", "BIENHEIM - LADANG PERAK RIVER", "ANGKASA TUNG 5", "LADANG KINTA VALEY,", "LADANG ALLAGAR", "LADANG REGENT", "LADANG GEDONG", "LADANG KEMPAS", "PARAMASIVAM - PARAMASIVAM BALAKRISHNAN", "LADANG TONG HING", "LADANG DINDING OIL MILL", "LADANG SG WANGI WALBROOK DIV", "PARAMASIVAM - VEERA RAJAN PERUMAL", "NSL - RUDRAPATHY SINNASAMY", "SANDRAN MUNIANDY CONT", "LADANG MANIKAVASAGAM", "LADANG SOMME", "LADANG SAGIL", "LADANG BOH, SG PALAS DIV", "KILANG GETAH BATU LINTANG", "LADANG RAJA MUSA", "NO MAILER - MLK", "LADANG SUNGAI SEBALING", "TAMILMANI CONT", "EMAIL - PHG", "RAJA FLOUR MILL", "LADANG SUNGAI BULOH", "LADANG BRISTOL", "LADANG DOVENBY", "LADANG SG PRAH", "BUKIT CHEEDING PACKING FACTORY", "LADANG GHIM KHOON", "LADANG JERAI", "LADANG RIVER VIEW", "LADANG BUKIT BELIMBING", "LADANG BUKIT PELANDOK", "LADANG BROOKLAND", "PARAMASIVAM - PARAMASIVAM KATAMUTHU", "LADANG NORTH,DIVISION 3", "LADANG SG KAWANG", "MLK - KRISHNAN CHINNA THAMBY", "KUPPUSAMY CONT", "LADANG BUKIT KERAYONG", "LOKONATHAM - MAGISPERAN", "SYARIKAT PERUSAHAAN KELAPA SAWIT SDN BHD", "LADANG TONG HEO", "VANNILLA - KUALA KETIL", "INDIVIDUAL - CIL", "LADANG RENJOK", "MLK - KALARANI A SIRAMAN", "LADANG AMPAR TENANG", "LADANG WEST,WORKSHOP", "LADANG NAGALELAI", "LADANG SERKAM", "LADANG EDENSOR", "MLK - RADHAKRISHNAN", "LADANG P.D. LUKUT", "LADANG CHEONG MENG", "LADANG SG SAMAK", "LOKONATHAM - THERUNAWOKKARASU SADAYAN", "ANGKASA TUNG 6", "LADANG TAMBANG", "LADANG TANAH MERAH", "LADANG COALFIELD", "LADANG ASSAM JAWA", "LOKONATHAM CONT", "LADANG SG LIMAU", "ANGKASA KDH", "LADANG KATI", "PARAMASIVAM - MOHANA GANESH", "PARAMASIVAM - GUNA SHEHARAN SUPPIAH", "LADANG SENGKANG", "LADANG BERTAM - PPG", "VANNILLA CONT", "LADANG KELABANG KEMPAS"]
  const postalCodes = [
    41000, 41200, 42000, 42500, 42600, 42690, 42900, 42960, 45200, 68100, 42510,
    42700, 45000, 41050, 42966, 46000, 73200, 77000, 77200, 80050, 81300, 81700,
    82000, 84900, 85400, 30100, 47650, 80350, 81100, 81110, 81200, 81800, 76100,
    79000, 79100, 79200, 81000, 81750, 83300, 84000, 85100, 86000, 41100, 45600,
    47620, 47630, 47640, 55200, 56100, 70300, 71010, 75050, 75450, 75460,
    760159, 80100, 36000, 43300, 71350, 72120, 73440, 80730, 81400, 81707,
    81810, 81850, 81900, 81920, 83700, 85000, 85010, 85030, 85300, 86007, 86300,
    86360, 86600, 10150, 34700, 40150, 47100, 47130, 68000, 70100, 71950, 81550,
    83000, 84200, 85009, 81050, 85500, 84060, 84300, 81150, 84150, 84500, 85020,
    86500, 80000, 51200, 81500, 80030, 77100, 70450, 71800, 84020, 86200, 58200,
    17510, 33700, 8000, 8100, 9000, 9300, 9700, 14300, 33100, 5300, 8300, 9010,
    9400, 9600, 34000, 62000, 2600, 5100, 5646, 6000, 6200, 8600, 9200, 9410,
    9500, 9800, 10350, 11900, 123456, 13000, 13020, 13200, 13300, 14000, 14100,
    14200, 34100, 83009000, 40000, 9810, 9100, 8007, 8010, 11700, 8020, 9009,
    9020, 7000, 32000, 12100, 13050, 18000, 47000, 5250, 9110, 920018, 72100,
    11200, 11950, 31350, 31400, 9310, 34200, 93000, 34900, 35500, 5200, 6010,
    6400, 6700, 80300, 8700, 8800, 9710, 11010, 11100, 11400, 12200, 13400,
    13500, 13600, 13700, 13800, 1400, 14020, 140200, 14110, 14400, 23700, 25200,
    27300, 30010, 300100, 31100, 31150, 31200, 31250, 31360, 31900, 32700,
    33200, 33300, 33400, 350800, 35800, 36700, 39200, 40400, 42100, 43150,
    43200, 43500, 46150, 47160, 47170, 47180, 47800, 48000, 50634, 52100, 53300,
    54000, 59200, 70200, 71050, 71450, 71700, 73000, 17500, 17509, 48020, 32400,
    75200, 73300, 73400, 75600, 76450, 76460, 77250, 77300, 77500, 78000, 40160,
    46700, 47600, 71300, 71900, 72000, 72500, 75150, 75250, 75350, 76350, 73500,
    75000, 75100, 75400, 75500, 75730, 42800, 71100, 16450, 37000, 71150, 78100,
    78300, 28300, 28200, 28400, 40170, 43000, 76110, 34600, 40460, 42450, 75260,
    84600, 28700, 70400, 71200, 72300, 27000, 28000, 47500, 43900, 47300, 75640,
    77700, 43700, 56000, 73430, 77550, 3000, 63000, 55100, 7700, 89009, 71000,
    80500, 75360, 48200, 55300, 71600, 75300, 28600, 30021, 35700, 35900, 43950,
    45700, 47150, 53200, 61000, 70000, 75075, 76400, 78460, 84400, 84800, 28330,
    31500, 39010, 48300, 53100, 71650, 71680, 7300, 73100, 735200, 75990, 77009,
    77600, 1000, 44300, 55000, 72109, 71109, 1233, 70700, 71009, 71209, 71400,
    71409, 71760, 71960, 72200, 73450, 721002, 25300, 35907, 721200, 73470,
    76500, 83500, 74000, 28800, 32040, 71250, 73309, 43002, 71260, 40300, 26820,
    65200, 7200, 7220, 71750, 27600, 72102, 72110, 70990, 714090, 42470, 52200,
    70430, 71459, 14120, 26700, 47190, 50470, 53000, 70540, 71060, 72600, 73420,
    28380, 25100, 25150, 25250, 26070, 26080, 26090, 26400, 26900, 27607, 28007,
    28260, 28340, 28500, 28620, 42200, 39000, 27310, 26000, 28009, 26800, 23000,
    25700, 28050, 2860, 31450, 10450, 11920, 36100, 34350, 30020, 36300, 36400,
    30200, 30450, 30730, 31000, 31300, 31550, 31600, 31650, 31800, 31920, 31950,
    32800, 32810, 33000, 33500, 33600, 34010, 34300, 34400, 34500, 34800, 35000,
    35600, 36008, 36009, 36020, 36200, 36500, 44000, 357800, 358000, 39600,
    32900, 31560, 32500, 30300, 31907, 31050, 39700, 34130, 34030, 32060, 34520,
    32200, 40470, 47810, 31420, 34120, 34140, 34510, 35410, 37500, 31750, 31850,
    36010, 363000, 36309, 46500, 12300, 26100, 312500, 33020, 35400, 41400,
    40200, 46100, 43800, 45800, 46400, 621104, 83200, 5582, 40100, 42300, 45400,
    47610, 40450, 41150, 41300, 41560, 41720, 420000, 42209, 42610, 43650,
    44109, 44200, 45300, 45500, 45660, 46050, 46200, 46300, 46350, 46720, 46800,
    47200, 47301, 47400, 47830, 48710, 50100, 50400, 50480, 51000, 51100, 52000,
    57500, 58000, 58100, 60000, 61800, 68200, 68300, 44100, 4500, 43807, 48050,
    57000, 84009, 41586, 427003, 47110, 41250, 45009, 48100, 11960, 47880,
    43350, 422200, 45900, 10460, 41080, 11300, 45790, 450000, 47910, 46600,
    59000, 8200, 15400, 16800, 18500, 50586, 88450, 89600, 91111, 93050, 93200,
    93250, 93350, 93400, 93450, 93560, 93728, 94000, 94200, 94300, 94700, 94800,
    98000, 98700, 15000, 15100, 15200, 16100, 16300, 16400, 17000, 17020, 17200,
    26200, 62502, 63350, 93100, 94600, 95000, 95450, 97000, 20700, 26500, 36800,
    69100, 21200, 21210, 21300, 30000, 31700, 32100, 32600, 32610, 35350, 43400,
    47120, 57100, 62250, 62300, 81560, 5150, 6550, 15050, 15300, 15350, 15990,
    16010, 16040, 16200, 16250, 20200, 21080, 21100, 26250, 26300, 26600, 26650,
    27200, 27400, 27610, 27800, 35820, 54100, 54200, 59100, 88400, 91000, 91007,
    91117, 91300, 91307, 93040, 93300, 93420, 93650, 95030, 96000, 96100, 96500,
    96507, 96700, 96800, 96850, 98400, 50490, 47410, 50990, 51800,
  ];
  const postalList = postalCodes.map((number) => number.toString());

  const [loanList,setLoanList ] = useState([])
  const [guarantorList,setGuarantorList ] = useState([])
  const [guarantorForList,setguarantorForList ] = useState([])
  const [shareCertList, setShareCertList ] = useState([])

  const [ColumnVisible, setColumneVisible] = useState([

    { field: "loanid", header: "Loan#", visible: true },
    { field: "loanstartdate", header: "LoanDate", visible: true, body: rowData => !rowData.loanstartdate ? null : dayjs(rowData.loanstartdate).format('DD-MM-YYYY') },
    { field: "principalamount", header: "Principal", visible: true },
    { field: "noofinstalment", header: "#inst", visible: true },
    { field: "loanexpirydate", header: "Expiry", visible: true, body: rowData => !rowData.loanexpirydate ? null : dayjs(rowData.loanexpirydate).format('DD-MM-YYYY') },
    { field: "loanbalanceamount", header: "LoanBalance", visible: true },


])
const [GuarantorColumnVisible, setGuarantorColumnVisible] = useState([
    { field: "guarantorid", header: "Guarantor", visible: true, style: { width: '80px' } },
    { field: "guarantorname", header: "MemberName", visible: true, style: { width: '350px' } },
    { field: "guarantoricno", header: "NRIC (New/Old)", visible: true },
    { field: "loanno", header: "Loan#", visible: true },
])
const [mgColumnVisible, setmgColumnVisible] = useState([
    { field: "memberid", header: "memberID", visible: true, style: { width: '80px' } },
    { field: "guarantorname", header: "MemberName", visible: true, style: { width: '350px' } },
    { field: "guarantoricno", header: "NRIC (New/Old)", visible: true },
    { field: "loanno", header: "Loan#", visible: true },
])
const [shareCertColumnVisible, setShareCertColumnVisible] = useState([
  { field: "actsharecertificateid", header: "Cert #", visible: true,},
  { field: "issueddate", header: "Printed Date", visible: true, body: rowData => !rowData.issueddate ? null : dayjs(rowData.issueddate).format('DD-MM-YYYY') },
  { field: "collecteddate", header: "Cert Collected Date", visible: true, body: rowData => !rowData.collecteddate ? null : dayjs(rowData.collecteddate).format('DD-MM-YYYY') },
  { field: "surrendeddate", header: "Surrended Date", visible: true, body: rowData => !rowData.surrendeddate ? null : dayjs(rowData.surrendeddate).format('DD-MM-YYYY') },
  { field: "statdecldate", header: "StatDecl Date", visible: true, body: rowData => !rowData.statdecldate ? null : dayjs(rowData.statdecldate).format('DD-MM-YYYY') },
])

  const setters1 = [
    setMemberNo,
    setMemberName,
    setMemberEmail,
    // setPassword,
    setSex,
    setRace,
    setOccupation,
    setNewNric,
    setOldNric,
    setTinNo,
    setOasisId,
    setAdress1,
    setAdress2,
    setAdress3,
    setAdress4,
    setPostal,
    setHouseTel,
    setOfficeTel,
    setHpNo,
    setBank,
    setAccNo,
    setEstate,
    setState,
    setNotes,
    setImagefile,
    setSelectedImage,
    setCorrAdress1,
    setCorrAdress2,
    setCorrAdress3,
    setCorrAdress4,
  ];
  const setters2 = [
    setMykad,
    setNomForm,
    setNomMykad,
    setDeathCert,
    setNomailer,
    setDispAction,
    setDirector,
    setObserver,
    setDelegate,
    setCompany,
    setNonBenefit,
    setImageStatus,
  ];

  const clearAllStates = () => {
    setEditDetails(false);
    setTerminateddate(null)
    setSearchMemberStatus(false);
    setMembererror("");
    setAge("")
    setHpWpNo("")
    setPassworderror("");
    setDeceaseddate(null)
    setDobError("");
    setDojError("");
    setNricError("");
    setMykadDateError("");
    setDelegateSinceError("")
    setEstateError("");
    setDob(null);
    setDoj(null);
    setDelegateSince(dayjs())
    setNotes(null)
    setters1.forEach((setState) => setState(""));
    setters2.forEach((setState) => setState(false));
    setInputs([
      // {
      //   nomineename: "",
      //   nomineeicno: "",
      //   relationship: "",
      //   percentage: "",
      //   age: "",
      // },
    ]);
    setLoanList([])
    setGuarantorList([])
    setguarantorForList([])
    setShareCertList([])
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const memberFilterArray = [
    { name: "Member ID", code: "memberid" },
    { name: "Member Name", code: "membername" },
    { name: "Estate", code: "estate" },
    { name: "State", code: "state" },
    { name: "My Kad", code: "newicno" },
    { name: "Old IC / NRIC", code: "oldicno" }
  ];
  const sexArray = [
    { name: "Male", code: "M" },
    { name: "Female", code: "F" },
  ];
  const raceArray = [
    { name: "Indian", code: "I" },
    { name: "Malay", code: "M" },
    { name: "Chinese", code: "C" },
    { name: "Others", code: "O" },
  ];

  const relationshipArray = [
    { name: "Mother", code: "M" },
    { name: "Father", code: "F" },
    { name: "Brother", code: "B" },
    { name: "Sister", code: "Sis" },
    { name: "Son", code: "Son" },
    { name: "Daughter", code: "D" },
    { name: "Husband", code: "H" },
    { name: "Wife", code: "W" },
  ];

  const [expanded, setExpanded] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  // useEffect( async ()=>{
  //     console.log(memberNo)
  //     if (memberNo!=="" && editdetails==true){
  //     await CustomAxios.get(`oasis/corres_address/?memberid=${parseInt(memberNo)}`).then((response)=>response.data.status==true?setCorrDel(true):setCorrDel(false))}

  // },[])

  useEffect(() => {
    let member_role = JSON.parse(window.sessionStorage.getItem("user_details"));
    ////console.log(member_role);
    if (
      member_role?.member_role !== "admin" &&
      member_role?.member_role !== "staff"
    ) {
      navigate("/login");
    }
    const gettingFormdetails = async () => {
      await CustomAxios.get(`oasis/form_details/`).then((data) => {
        setBanks(data.data.bankName);
        const states = data.data.stateList.map((state) => state.statedesc);
        const estates = data.data.estateList.map((estate) => estate.estatename);
        setOccupationArray(data.data.occupations);
        setStates(states);
        setEstatesArray(estates);
        setEsatateList(data.data.estateList);
      });
    };
    gettingFormdetails();
  }, []);
  let bankList = banks
    .filter((data) => data.bankname !== null)
    .map((filteredData) => filteredData.bankname);

  const changeDateformat = (date) => {
    const originalDate = new Date(date);
    let formattedDate;
    try {
      formattedDate = originalDate.toISOString().split("T")[0];
    } catch (e) {
      ////console.log(e);
    }
    return formattedDate;
  };
  // useEffect(() => {
  //   checkForEmptyObjects(inputs);
  // }, [inputs]);
  const handleSignup = (e, model = false) => {
    // Add your signup logic here
    e.preventDefault();
    if (
      memberName?.trim() == "" ||
      !dob ||
      dob.$d == "Invalid Date" ||
      !doj ||
      doj.$d == "Invalid Date" ||
      (!newNric?.trim() && !oldNric?.trim()) ||
      (deceaseddate && deceaseddate.$d == "Invalid Date") ||
      (terminateddate && terminateddate.$d == "Invalid Date") ||
      (delegate && !delegatesince) || 
      estate?.trim() == "" || estate == null
    ) {
      memberName?.trim() == ""
        ? setMembererror("Member name required")
        : setMembererror("");
      // memberEmail==""?setEmailerror("Email id required"):setEmailerror("")
      setPassworderror("");
      !dob || dob.$d == "Invalid Date"
        ? setDobError(!dob ? "DOB required" : "Invalid Date")
        : setDobError("");
      !doj || doj.$d == "Invalid Date"
        ? setDojError(!doj ? "DOJ required" : "Invalid Date")
        : setDojError("");
      !oldNric?.trim() && !newNric?.trim()
        ? setNricError("New (or) Old NRIC required")
        : setNricError("");
      deceaseddate && deceaseddate.$d == "Invalid Date"
        ? setDeceasedError("Invalid Date")
        : setDeceasedError("");
      terminateddate && terminateddate.$d == "Invalid Date"
        ? setTerminatedError("Invalid Date")
        : setTerminatedError("");
      delegate && !delegatesince
        ? setDelegateSinceError(delegate ? "Delegate Since required" : "Invalid Date")
        : setDelegateSinceError("");
      estate?.trim() == "" || estate == null
        ? setEstateError("Estate is required")
        : setEstateError("");
      // nomName==""?setNomNameError("Nominee Name required"):setNomNameError("")
      // nomicno==""?setNomIcError("Nominee NRIC Number required"):setNomIcError("")
      // relationship==""?setRelError("Relationship required"):setRelError("")
      // percentshare==""?setPerError("Percentage of share required"):setPerError("")
    } else {
      e.preventDefault();
      ////console.log(dob);
      //console.log(doj);
      if (checkForEmptyObjects(inputs, "create") === null){
        if(!model) {
          return
        }
      }
      let photo;
      if (imageStatus == true) {
        photo = "Y";
      } else {
        photo = "N";
      }
      let bankName = "";
      if (bank != "") {
        bankName = bank?.trim() ?? "";
      }
      let formattedDoj = doj?.format("YYYY-MM-DDTHH:mm:ss[Z]");
      let formattedDob = dob?.format("YYYY-MM-DDTHH:mm:ss[Z]");

      let t_Date =
        terminateddate && terminateddate.$d != "Invalid Date"
          ? terminateddate?.format("YYYY-MM-DDTHH:mm:ss[Z]")
          : "";
      let d_Date =
        deceaseddate && deceaseddate.$d != "Invalid Date"
          ? deceaseddate?.format("YYYY-MM-DDTHH:mm:ss[Z]")
          : "";

      // For member creation, backend expects password to be created as empty string.
      const passwordToSend = "";
      const payload = {
        emailid: memberEmail,
        membername: memberName,
        password: passwordToSend,
        password2: passwordToSend,
        newicno: newNric,
        oldicno: oldNric,
        tin_no: tinNo,
        add1: adress1,
        add2: adress2,
        add3: adress3,
        add4: adress4 ?? null,
        state: state ?? null,
        postalcode: postal,
        sex: sex ?? null,
        race: race ?? null,
        occupation: occupation ?? null,
        terminated: !t_Date ? "N" : "Y",
        phoneno: houseTel,
        phone2: officeTel,
        mobileno: hpNo,
        whatsappno: hpWpNo,
        m_acctno: accNo,
        notes: notes,
        estate: estate ?? null,
        status: mykad,
        mykadnominee: nommykad,
        deathcertfile: deathcert,
        dob: formattedDob,
        doj: formattedDoj,
        nomail: nomailer,
        deceased: !d_Date ? false : true,
        disciplinaryaction: dispaction,
        director: director,
        observer: observer,
        delegates: delegate,
        company: company,
        nonbenifit: nonbenifit,
        photo: photo,
        entryfee: entryFee,
        mykadnominee: nommykad,
        nominationletter: nomform,
        m_bankname: bank ?? null,
        m_bank: bankName + " " + accNo,
        junior: nonbenifit,
        delegatesince: delegate?delegatesince?.format('YYYY'):'',
        terminateddate: t_Date!==""?t_Date:null,
        deathdate: d_Date!==""?d_Date:null,
        nominee_details:
          inputs.length > 0
            ? Object.values(inputs[0]).every((value) => value === "")
              ? []
              : inputs
            : [],
      };

      // Send data to the API endpoint using Axios (replace with your actual API endpoint)
      CustomAxios.post(`oasis/MemberSignup/`, payload)
        //axios.post('http://127.0.0.1:8000/oasis/MemberSignup/', payload)
        .then((response) => {
          // Handle API response as needed
          //console.log("API Response:", response);
          dispatch(updateMemberListPayload(response.data.details));
          const auth_data = response.data.data;
          // formRef.current.reset()
          clearAllStates();
          setNomineeModel(false);
          // setMemberNo(auth_data.memberid)
          setResponse(auth_data);
          setSuccess(true);
          if (auth_data.memberid != "" && imagefile !== "") {
            handleUpload(imagefile, auth_data.memberid);
          }
        })
        .catch((error) => {
          //console.error("Error:", error);
        });
    }
  };
  const handleUpload = (file, member) => {
    // Check if a file is selected
    if (file) {
      const formData = new FormData();
      formData.append("file_url", file);
      formData.append("memberid", member);

      CustomAxios.post(`oasis/photoupload/`, formData).then((response) => {
        // Handle the response as needed
        const auth_data = response.data;
        setNomineeresponse(auth_data);
        if (auth_data.success === "Uploaded Successfully!") {
        }
      });
    }
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    setImagefile(event.target.files[0]);

    const formData = new FormData();
    //console.log("here");

    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        setSelectedImage(e.target.result);
        setImageStatus(true);
      };

      reader.readAsDataURL(file);
      event.target.value = null;
    }
  };

  const handleDelete = (memberId) => {
    CustomAxios.delete(`oasis/photoupload/?memberid=${memberId}`).then((response) => {
    }).catch((err) => console.error(err))
  }

  const getLoanGuarantor = async (memberId) => {
    try {
        if(memberId){
            const response = await CustomAxios.get(`oasis/specificGuarantor/?mid=${parseInt(memberId)}&type=memProfile`);
            setLoanList(response.data.loan)
            setGuarantorList(response.data.guarantor)
            setguarantorForList(response.data.memberGuarantor)
            setShareCertList(response.data.shareCertificates)
        }

    } catch (error) {
        console.error("Error fetching member details:", error);
    }
}

  const search = (e, member) => {
    e.preventDefault();
    clearAllStates();
    if (memberNo || member.memberid) {
      setTableLoader(true);
      try {
        let payload;
        if (memberNo != "" || member.memberid) {
          payload = {
            memberid: member.memberid !== "" ? member.memberid : memberNo,
          };
        }
        if (memberNo != "" || member.memberid) {
          CustomAxios.get(
            `oasis/photoupload/?memberid=${
              member.memberid !== "" ? member.memberid : memberNo
            }`,
            { responseType: "arraybuffer" }
          )
            .then((response) => {
              const byteArray = new Uint8Array(response.data);
              const binaryString = byteArray.reduce(
                (binary, byte) => binary + String.fromCharCode(byte),
                ""
              );
              const base64String = btoa(binaryString);
              const dataUrl = `data:image/jpeg;base64,${base64String}`;
              setSelectedImage(dataUrl);
              setImageStatus(true);
            })
            .catch((error) => setImageStatus(false));
        }
        CustomAxios.post(`oasis/getmember/`, payload)
          .then((data) => {
            let res_data = data.data;
            setSearchMember("");
            setFilteredMemberlist([]);
            setColumnFilteredMemberlist([]);
            setColumnFilters({
              memberid: '',
              membername: '',
              estate: '',
              state: '',
              newicno: '',
              oldicno: ''
            });
            setMemberSuccess();
            setMemberNo(res_data.memberid);
            setMemberEmail(res_data.emailid);
            setMemberName(res_data.membername);
            // setPassword();
            setNewNric(res_data.newicno);
            setOldNric(res_data.oldicno);
            setTinNo(res_data.tin_no);
            setOasisId(res_data.oasis_id);
            setAdress1(res_data.add1);
            setAdress2(res_data.add2);
            setAdress3(res_data.add3);
            setAdress4(res_data.add4);
            setCorrAdress1(res_data.corress_address?.corr_add1);
            setCorrAdress2(res_data.corress_address?.corr_add2);
            setCorrAdress3(res_data.corress_address?.corr_add3);
            setCorrAdress4(res_data.corress_address?.corr_add4);
            // setState(res_data.state)
            setPostal(res_data.postalcode);
            setSex(res_data.sex);
            setRace(res_data.race);
            setOccupation(res_data.occupation);
            setHpNo(res_data.mobileno);
            setHpWpNo(res_data.whatsappno);
            setAccNo(res_data.m_acctno);
            setNotes(res_data.notes);
            setEstate(res_data.estate);
            setPstatus(res_data.photo);
            setMembershipNo(res_data.oasis_id);
            setDeathCert(res_data.deathcertfile);
            setDob(dayjs(res_data.dob, "YYYY/MM/DD"));
            setDoj(dayjs(res_data.doj, "YYYY/MM/DD"));
            setNomailer(res_data.nomail);
            // setDeceased(res_data.deceased)
            setDispAction(res_data.disciplinaryaction);
            setDirector(res_data.director);
            setObserver(res_data.observer);
            setDelegate(res_data.delegates);
            setDelegateSince(dayjs(res_data.delegatesince));
            setCompany(res_data.company);
            setEntryFee(res_data.entryfee);
            setAge(CalculateAge(res_data.dob));
            setMykad(res_data?.status)
            setNomineeList(res_data.nominee_details);
            setInputs(res_data.nominee_details.map(nom => ({...nom, age: handlenricAge(nom.nomineeicno)})));
            setNomForm(res_data.nominationletter);
            setNomMykad(res_data.mykadnominee);
            setDeathCert(res_data.deathcertfile);
            setHouseTel(res_data.phoneno);
            setOfficeTel(res_data.phone2);
            const spacesToAdd = 50 - res_data?.m_bankname?.length;
            const paddedString = res_data?.m_bankname?.padEnd(
              res_data?.m_bankname?.length + spacesToAdd,
              " "
            );
            setBank(paddedString);
            setNonBenefit(res_data.junior);
            if (res_data?.terminateddate)
              setTerminateddate(
                dayjs(res_data.terminateddate?.trim(), "YYYY/MM/DD")
              );
            if (res_data?.deathdate)
              setDeceaseddate(dayjs(res_data.deathdate?.trim(), "YYYY/MM/DD"));
            setSearchMemberStatus(true);
            setMembererror("");
            setPassworderror("");
            setDobError("");
            setDojError("");
            setNricError("");
            setMykadDateError("");
            setEstateError("");
            getLoanGuarantor(payload.memberid)
            // Once data is fetched, stop the loader and show success message
            setTableLoader(false);  // Set loader to false
            setSnackbarArray({ msg: 'Member Details Fetched Successfully', color: 'green' }); 
          })
          .catch((err) => {
            console.error(err);
          });
      } catch (err) {
        console.error(err);
        // errors.member= "not available";
      }
    }
  };

  const isObjectEmpty = (obj) => {
    return Object.keys(obj).some(key => searchMemberStatus ? obj[key] === '' : key !== 'memberid' && obj[key] === '');
  };

  const checkForEmptyObjects = (array, type) => {
      if (array.length === 0) {
        // setActive("Nominee Information");
        setNomineeModel(true);
        if(type == "create") {
          setNomineeModelType("create");
        }
        else {
          setNomineeModelType("edit")
        }
        // setNomineeError(`Nominee details should not be empty`);
        return null
      }
      else {  
        const emptyObjects = array.filter(isObjectEmpty);
        if(emptyObjects.length > 0) {
          setActive("Nominee Information")
          setNomineeError(`All the Nominee details should be filled to proceed further`);
          return null
        } else {
          setNomineeError(''); // Clear the error if no empty objects are found
          return "sucess"
        }
      }   
  };
  const updateMember = async () => {
    
    if (
      memberName?.trim() == "" ||
      password?.trim() == "" ||
      !dob ||
      dob.$d == "Invalid Date" ||
      !doj ||
      doj.$d == "Invalid Date" ||
      (!newNric?.trim() && !oldNric?.trim()) ||
      (deceaseddate && deceaseddate.$d == "Invalid Date") ||
      (terminateddate && terminateddate.$d == "Invalid Date") ||
      nomineeError !== "" || 
      (delegate && !delegatesince) || 
      estate?.trim() == "" || estate == null
    ) {
      memberName?.trim() == ""
        ? setMembererror("Member name required")
        : setMembererror("");
      // memberEmail==""?setEmailerror("Email id required"):setEmailerror("")
      password?.trim() == ""
        ? setPassworderror("Password required")
        : setPassworderror("");
      !dob || dob.$d == "Invalid Date"
        ? setDobError(!dob ? "DOB required" : "Invalid Date")
        : setDobError("");
      !doj || doj.$d == "Invalid Date"
        ? setDojError(!doj ? "DOJ required" : "Invalid Date")
        : setDojError("");
      !oldNric?.trim() && !newNric?.trim()
        ? setNricError("MyKAD (or) NRIC required")
        : setNricError("");
      deceaseddate && deceaseddate.$d == "Invalid Date"
        ? setDeceasedError("Invalid Date")
        : setDeceasedError("");
      terminateddate && terminateddate.$d == "Invalid Date"
        ? setTerminatedError("Invalid Date")
        : setTerminatedError("");
      delegate && !delegatesince
        ? setDelegateSinceError(delegate ? "Delegate Since required" : "Invalid Date")
        : setDelegateSinceError("");
      estate?.trim() == "" || estate == null
        ? setEstateError("Estate is required")
        : setEstateError("");
    } else {
      let formattedDoj = doj?.format("YYYY-MM-DDTHH:mm:ss[Z]");
      let formattedDob = dob?.format("YYYY-MM-DDTHH:mm:ss[Z]");
      let bankName;
      let photo;
      if (bank != "") {
        bankName = bank?.trim() ?? "";
      }
      if (imageStatus == true) {
        photo = "Y";
      } else {
        photo = "N";
      }
      let t_Date =
        terminateddate && terminateddate.$d != "Invalid Date"
          ? terminateddate?.format("YYYY-MM-DDTHH:mm:ss[Z]")
          : "";
      let d_Date =
        deceaseddate && deceaseddate.$d != "Invalid Date"
          ? deceaseddate?.format("YYYY-MM-DDTHH:mm:ss[Z]")
          : "";

      const payload = {
        memberNo: memberNo,
        emailid: memberEmail,
        membername: memberName,
        password: password,
        password2: password,
        nricnew: newNric,
        nricold: oldNric,
        tin_no: tinNo,
        add1: adress1,
        add2: adress2,
        add3: adress3,
        add4: adress4 ?? null,
        state: state ?? null,
        postalcode: postal,
        sex: sex ?? null,
        race: race ?? null,
        occupation: occupation ?? null,
        terminated: !t_Date ? "N" : "Y",
        phoneno: houseTel,
        phone2: officeTel,
        mobileno: hpNo,
        whatsappno:hpWpNo,
        m_acctno: accNo,
        notes: notes,
        estate: estate ?? null,
        // pmykad:mykad,
        // nomform:nomform,
        // mykadnominee:nommykad,
        // deathcertfile:deathcert,
        dob: formattedDob,
        doj: formattedDoj,
        nomail: nomailer,
        deceased: !d_Date ? false : true,
        disciplinaryaction: dispaction,
        director: director,
        observer: observer,
        delegates: delegate,
        delegatesince: delegate?delegatesince?.format('YYYY'):'',
        company: company,
        photo: photo,
        deathcertfile: deathcert,
        mykadnominee: nommykad,
        nominationletter: nomform,
        status: mykad,
        m_bankname: bank?.trim() ?? null,
        m_bank: bankName + " " + accNo,
        junior: nonbenifit,
        nominee_details:
          inputs.length > 0
            ? Object.values(inputs[0])?.every((value) => value === "")
              ? []
              : inputs
            : [],
        terminateddate: t_Date,
        deathdate: d_Date,

        // memberid: memberId,
      };
      if(!imageStatus && selectedImage) {
        handleDelete(memberNo)
      }
      else if (imagefile) {
        handleUpload(imagefile, memberNo);
      }

      const response = await CustomAxios.post("oasis/memberEdit/", payload);
      //console.log(response);
      setMemberSuccess(response.data.success);
      setNomineeModel(false);
      setEditDetails(false);
    }
  };
  
  let timeout;
  let numbers = Array.from({ length: 50000 }, (_, index) => index + 1);

  // const debouncedSearch = (searchQuery) => {
  //   clearTimeout(timeout);
  //   timeout = setTimeout(async () => {
  //     try {
  //       const payload = {
  //         search:parseInt(searchQuery)
  //       }
  //       const response = axios.post(`${process.env.REACT_APP_OASIS_BE_URL}oasis/memberList/`, payload)
  //       console.log(response)
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //     }
  //   }, 1000); // Adjust the debounce delay as needed (e.g., 300ms)
  // };

  const handleMemberChange = (e) => {
    setMemberNo(e.target.value);
  };

  const handleNameChange = (e) => {
    setMemberName(e.target.value);
  };

  const isMobile = useMediaQuery({ maxWidth: 600 });
  const handleEnter = (e) => {

    if (e.key == "Enter") {
      if (searchMember?.trim() !== "" && memberList.length > 0) {
        setColumnFilters({
          memberid: '',
          membername: '',
          estate: '',
          state: '',
          newicno: '',
          oldicno: ''
        });
        const filteredMember = memberList
        .filter((mem) => {
          // console.log("Checking member:", mem);
          if (selectedFilter) {
            // Filter by the selected field based on user input
            return mem[selectedFilter]?.toString().toLowerCase().startsWith(searchMember?.trim().toLowerCase());
          }
          return false; // No filter selected, no results
      
          // return (
          //   mem.membername
          //     .toLowerCase()
          //     .startsWith(searchMember?.trim().toString().toLowerCase()) ||
          //   mem.memberid.toString().startsWith(searchMember?.trim()) ||
          //   (mem.oldicno !== null &&
          //     mem.oldicno.toString().startsWith(searchMember?.trim())) ||
          //   (mem.newicno !== null &&
          //     mem.newicno.toString().startsWith(searchMember?.trim()))
          // );
        })
        // .slice(0, 100);  
      // console.log("filtered member-------", filteredMember)
      setFilteredMemberlist(filteredMember);
      setColumnFilteredMemberlist(filteredMember);
      
      }
    }
    // console.log(memb)
    // if (e.key == "Enter") {
    //   const mem = memberList.filter((Member) => {
    //     console.log("member---", Member);
    //     return (
    //       Member.memberid == searchMember ||
    //       Member.oldicno == searchMember ||
    //       Member.newicno == searchMember
    //     );
    //   });
    //   mem.length == 1 && setMemberNo(mem[0].memberid);
    //   dispatch(updateMemberid(mem[0]?.memberid));
    //   dispatch(updateKeyIn(true));
    //   mem.length == 1 && search(e, mem[0]);
    // }
  };

  // Handle changes in the filter dropdown
  const handleFilterChange = (event, value) => {
    setSelectedFilter(value);
  };
  const handleRelationshipFilterChange = (index, event, newValue) => {
    const updatedInputs = [...inputs];
    updatedInputs[index].relationship = newValue;
    // Update the relationship field with the selected option
    handleInputChangeNominees(index, event);
  };


  // Handle individual column filters
  const handleColumnFilter = (column, value) => {
    const updatedFilters = { ...columnFilters, [column]: value };
    setColumnFilters(updatedFilters);

    // Apply filters to the table data

    let filtered = filteredMemberList.filter((item) => {
      return Object.keys(updatedFilters).every((key) => {
        const filterValue = updatedFilters[key].toLowerCase();
        return (
          !filterValue || // If the filter value is empty, don't filter this column
          item[key] && item[key].toString().toLowerCase().startsWith(filterValue)
        );
      });
    });
    setColumnFilteredMemberlist(filtered);
  };

  const [lazyLoading, setLazyLoading] = useState(false);
  //    useEffect(() => {
  //     let cancelled = false;

  //     async function fetchData() {

  //     setLazyLoading(true)
  //         const res = await axios.get(`${process.env.REACT_APP_OASIS_BE_URL}/oasis/memberList/?page=${page}`)
  //         if (!cancelled) {
  //             // setMemberList(prev=> [...prev, ...res.data.memberList])
  //         //   memberList.push(...res.data.memberList);
  //         }
  //     setLazyLoading(false)

  //     }

  //     fetchData();

  //     return () => {
  //       cancelled = true;
  //     }
  //   }, [page]);

  const [virtualMem, setVirtualmem] = useState(Array.from({ length: 100000 }));
  let loadLazyTimeout = null;
  const loadCarsLazy = (event) => {
    !lazyLoading && setLazyLoading(true);

    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let _virtualMem = [...virtualMem];
      let { first, last } = event;
      const loadedMem = memberList.slice(first, last);
      Array.prototype.splice.apply(_virtualMem, [
        ...[first, last - first],
        ...loadedMem,
      ]);

      setVirtualmem(_virtualMem);
      setLazyLoading(false);
    }, Math.random() * 1000 + 250);
  };

  const loadingTemplate = (options) => {
    return (
      <div
        className="flex align-items-center"
        style={{ height: "100%", flexGrow: "1", overflow: "hidden" }}
      >
        <Skeleton
          width={
            options.cellEven
              ? options.field === "year"
                ? "30%"
                : "40%"
              : "60%"
          }
          height="1.5rem"
        />
      </div>
    );
  };
  const getPic = (rowData) => {
    return (
      <>
        <Button
          sx={{
            display: "flex",
            gap: "16px",
            padding: "12px 24px",
            alignItems: "center",
            justifyContent: "flex-start",
            background: memberNo == rowData.memberid ? "#DCFCE7" : "#FFF",
          }}
          onClick={(e) => handleFill(e, rowData)}
        >
          {selectedImage ? (
            <Box
              component="img"
              src={selectedImage}
              sx={{
                width: "40px",
                maxHeight: "40px",
                borderRadius: "20px",
                objectFit: "cover",
              }}
            ></Box>
          ) : (
            <Box
              sx={{
                width: "40px",
                maxHeight: "40px",
                borderRadius: "20px",
                objectFit: "cover",
              }}
            >
              <AccountCircleTwoToneIcon />
            </Box>
          )}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              width: "214px",
              justifyContent: "flex-start",
            }}
          >
            <Typography
              sx={{
                fontFamily: "inter",
                fontWeight: "400",
                fontSize: "12px",
                lineHeight: "16px",
                color: "#101010",
                textAlign: "left",
              }}
            >
              {rowData.memberid}
            </Typography>
            <Typography
              sx={{
                fontFamily: "inter",
                fontWeight: "600",
                fontSize: "16px",
                lineHeight: "24px",
                color: "#101010",
                textAlign: "left",
              }}
            >
              {rowData.membername}
            </Typography>
            <Box sx={{ display: "flex", gap: "12px" }}>
              <Typography
                sx={{
                  fontFamily: "inter",
                  fontWeight: "400",
                  fontSize: "12px",
                  lineHeight: "16px",
                  color: "#101010",
                  textAlign: "left",
                }}
              >
                {rowData.newNric !== null && rowData.oldNric !== null
                  ? `NRC (New):${rowData.newNric}`
                  : `NRC (old):${rowData.oldNric}`}
              </Typography>
            </Box>
          </Box>
        </Button>
      </>
    );
  };
  const [columnVisible, setColumnVisible] = useState([
    {
      visible: true,
      style: { width: "100px" },
      body: getPic,
      style: { padding: 0, cursor: "pointer" },
    },
  ]);
  const loadFile = () => {
    document.getElementById("image-upload").click();
  };
  const handleInputChangeNominees = (index, event) => {
    const { name, value } = event.target;
    const newInputs = [...inputs];
    newInputs[index][name] = event.target.value;
    newInputs[index]["memberid"] = memberNo;
    if (name == "nomineeicno") {
      newInputs[index]["age"] = handlenricAge(event.target.value);
    }
    //console.log(event.target.value);
    setInputs(newInputs);
  };

  const handleAddMoreNominee = (e) => {
    e.preventDefault();
    const newInputs = [...inputs];
    const newIndex = newInputs.length + 1;
    newInputs.push({
      nomineename: "",
      nomineeicno: "",
      relationship: "",
      percentage: "",
      age: "",
    });
    setInputs(newInputs);
  };

  const handleRemoveNominee = (e, index) => {
    e.preventDefault();
    const newInputs = [...inputs];
    newInputs.splice(index, 1);
    setInputs(newInputs);
    setNomineeError('')
  };
  /** Parse YYMMDD from MyKAD / NRIC; validates real calendar dates and century (same rule as before). */
  const parseMyKadBirthFromNric = (nricRaw) => {
    if (nricRaw == null || String(nricRaw).trim() === "") {
      return { ok: false, message: "" };
    }
    const digits = String(nricRaw).replace(/\D/g, "");
    if (digits.length < 6) {
      return { ok: false, message: "" };
    }
    const yyStr = digits.slice(0, 2);
    const mm = parseInt(digits.slice(2, 4), 10);
    const dd = parseInt(digits.slice(4, 6), 10);
    if (Number.isNaN(mm) || Number.isNaN(dd)) {
      return {
        ok: false,
        message: "Invalid characters in the birth date (first 6 digits) of MyKAD.",
      };
    }
    if (mm < 1 || mm > 12) {
      return { ok: false, message: "Invalid month in MyKAD (digits 3–4 must be 01–12)." };
    }
    if (dd < 1 || dd > 31) {
      return { ok: false, message: "Invalid day in MyKAD (digits 5–6 must be 01–31)." };
    }

    const dateObj = new Date();
    const currentYearStr = dateObj.getFullYear().toString();
    const lastTwoChars = currentYearStr.slice(-2);
    const firstTwoYearChars = currentYearStr.slice(0, 2);
    const yyNum = parseInt(yyStr, 10);
    const currYY = parseInt(lastTwoChars, 10);
    const yearselected =
      yyNum > currYY && yyNum <= currYY + 100
        ? parseInt(firstTwoYearChars, 10) - 1
        : parseInt(firstTwoYearChars, 10);
    const fullYear = parseInt(
      `${yearselected}${yyStr.padStart(2, "0")}`,
      10
    );

    const cal = new Date(fullYear, mm - 1, dd);
    if (
      cal.getFullYear() !== fullYear ||
      cal.getMonth() !== mm - 1 ||
      cal.getDate() !== dd
    ) {
      return {
        ok: false,
        message: "Invalid date in MyKAD (that day does not exist in that month).",
      };
    }

    const startOfToday = new Date();
    startOfToday.setHours(23, 59, 59, 999);
    if (cal > startOfToday) {
      return {
        ok: false,
        message: "Birth date derived from MyKAD cannot be in the future.",
      };
    }

    const y = String(fullYear);
    const m = String(mm).padStart(2, "0");
    const d = String(dd).padStart(2, "0");
    const isoDate = `${y}-${m}-${d}T00:00:00Z`;
    const dobDayjs = dayjs(`${y}-${m}-${d}`);
    return { ok: true, isoDate, dayjs: dobDayjs };
  };

  const handlenricAge = (nric) => {
    const parsed = parseMyKadBirthFromNric(nric);
    if (!parsed.ok) {
      return "";
    }
    return CalculateAge(parsed.isoDate);
  };

  const CalculateAge = (dob) => {
    const currentDate = new Date();
    const birthDateObj = new Date(dob);
    const currentDateObj = new Date(currentDate);
    const timeDiff = currentDateObj - birthDateObj;
    const age = Math.floor(timeDiff / (1000 * 60 * 60 * 24 * 365.25)) ;
    return age;
  };

  const handleCorrespondanceSave = async (e, param) => {
    if (editdetails == true) {
      //console.log(corradress1);
      setcorressAddressError("");
      const payload = {
        memberid: memberNo,
        corr_add1: corradress1 == undefined ? "" : corradress1,
        corr_add2: corradress2 == undefined ? "" : corradress2,
        corr_add3: corradress3 == undefined ? "" : corradress3,
        corr_add4: corradress4 == undefined ? "" : corradress4,
        update: param == "delete" ? "delete" : editdetails,
      };
      const response = await CustomAxios.post("oasis/corres_address/", payload);
      if (response.data.data.response == "Registration Successful!") {
        setCorresSuccess(true);
      } else if (response.data.data.message == "Record successfully deleted") {
        setCorresDeleted(true);
        setCorrAdress1("");
        setCorrAdress2("");
        setCorrAdress3("");
        setCorrAdress4("");
      }
    } else if (
      corradress1 === "" &&
      corradress2 === "" &&
      corradress3 === "" &&
      corradress4 === "" &&
      editdetails != true
    ) {
      setcorressAddressError(
        "Please fill in all fields of the correspondence address."
      );
    }
  };
  const handlePage = (e) => {
    e.preventDefault();
    // let count = pge+1
    // setPage(count)
  };
  const handleNomineeCount = (e) => {
    e.preventDefault();
    let count = nomineeCount + 1;
    setNomineeCount(count);
  };
  const handleFill = (e, mem, ind) => {
    e.preventDefault();
    setSelectedRow(ind);
    // Highlight the row for 2 seconds and then execute further actions
    // setTimeout(() => {
      setSelectedRow(null); // Remove highlight
      dispatch(updateMemberid(mem.memberid));
      dispatch(updateKeyIn(true));
      setMemberNo(mem.memberid);
      search(e, mem);
    // }, 3000);
  };
  const handleNewicnoChange = (e) => {
    const newic = e.target.value;
    setNewNric(newic);
    const digits = newic.replace(/\D/g, "");
    if (digits.length < 6) {
      setMykadDateError("");
      const filteredMembersEarly = memberList.filter(
        (member) => member.newicno && member.newicno === newic?.trim()
      );
      if (filteredMembersEarly.length > 0) {
        setMemberNric(filteredMembersEarly[0]);
        setSearchBulkDialogopen(true);
      }
      return;
    }

    const parsed = parseMyKadBirthFromNric(newic);
    if (!parsed.ok) {
      setMykadDateError(parsed.message || "Invalid birth date in MyKAD.");
      setDob(null);
      setAge("");
    } else {
      setMykadDateError("");
      setDob(parsed.dayjs);
      setAge(CalculateAge(parsed.isoDate));
    }

    const filteredMembers = memberList.filter(
      (member) => member.newicno && member.newicno === newic?.trim()
    );

    if (filteredMembers.length > 0) {
      //console.log(filteredMembers);
      setMemberNric(filteredMembers[0]);
      setSearchBulkDialogopen(true);
    } else {
      //console.log("No match");
    }
  };
  useEffect(() => {
    // if (searchMember?.trim() !== "" && memberList.length > 0) {
    //   console.log("searching continues------")
    //   setColumnFilters({
    //     memberid: '',
    //     membername: '',
    //     estate: '',
    //     state: '',
    //   });
    //   const filteredMember = memberList
    //   .filter((mem) => {
    //     // console.log("Checking member:", mem);
    
    //     return (
    //       mem.membername
    //         .toLowerCase()
    //         .startsWith(searchMember?.trim().toString().toLowerCase()) ||
    //       mem.memberid.toString().startsWith(searchMember?.trim()) ||
    //       (mem.oldicno !== null &&
    //         mem.oldicno.toString().startsWith(searchMember?.trim())) ||
    //       (mem.newicno !== null &&
    //         mem.newicno.toString().startsWith(searchMember?.trim()))
    //     );
    //   })
    //   // .slice(0, 100);
    
    // setFilteredMemberlist(filteredMember);
    // setColumnFilteredMemberlist(filteredMember);
    
    // }
    if(searchMember == ""){
      setFilteredMemberlist([]);
      setColumnFilteredMemberlist([]);
      setColumnFilters({
        memberid: '',
        membername: '',
        estate: '',
        state: '',
        newicno: '',
        oldicno: ''
      });
    }

    if (
      memberNo !== "" &&
      response &&
      response.response == "Registration Successful!"
    ) {
      // let filterdNominee
      // if(memberList.length>0){
      //  filterdNominee = inputs.filter((nom)=>!nomineeList.some((n)=>nom.nomineeicno==n.nomineeicno))
      //  console.log(filterdNominee)
      //  filterdNominee.map((nom)=>nom['memberid']=memberNo)
      // }
      inputs.map((nom) => (nom["memberid"] = memberNo));
      const NomineePayload = inputs;
      CustomAxios.post(`oasis/addNominee/`, NomineePayload)
        //axios.post('http://127.0.0.1:8000/oasis/addNominee/', payload)
        .then((response) => {
          //console.log("API Response:", response);
          const auth_data = response.data;
          setNomineeresponse(auth_data);
          if (auth_data.response == "success") {
            //console.log("we are here");
            //console.log(auth_data);
            // navigate('/login'); // Change to your desired route
          } else {
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }, [searchMember, response]);
  useEffect(() => {
    if (
      editdetails &&
      (terminateddate === new Date() || deceaseddate === new Date())
    ) {
      setTerminateddate(new Date());
      setDeceaseddate(new Date());
    }
  }, [editdetails]);

  useEffect(() => {
    //console.log("+++++++++++++++++++++++++++++++++++");
    if (estate !== "") {
      const filterdEstate = estateList.filter(
        (est) => est.estatename == estate
      );
      const state = filterdEstate[0]?.state;
      //console.log("---------------------", state, filterdEstate);
      setState(state!==undefined?state:"");
    }
  }, [estate]);
  // const handleBlur = () => {
  //     // Filter memberList based on newicno
  //     const filteredMembers = memberList.filter(
  //         member => member.newicno !== null && member.newicno === newNric
  //     );

  //     if (filteredMembers.length > 0) {
  //         console.log(filteredMembers)
  //         setMemberNric(filteredMembers[0])
  //         setSearchBulkDialogopen(true)
  //     } else {
  //         console.log('No match');
  //     }
  // };

  const handlePermanentAddress3Change = (e) => {
    setAdress3(e.target.value)
    !isNaN(e.target.value.split(' ')[0]) && setPostal(e.target.value.split(' ')[0])
  }

  const handleFetchAndPrintReceipt = async () => {
    try {
      let payload, dateFormate;
      console.log(recordtype, transType,dates)
      console.log(recordtype === "" &&
        (transType == "share_transactions" ||
          transType == "subscription_transactions"))
      if (dates && dates.length > 0) {
            dateFormate = dates.map(item => {
                const originalDate = new Date(item);
                const formattedDate = `${originalDate.getFullYear()}-${originalDate.getMonth() + 1}-${originalDate.getDate()}`;
                const [day, month, year] = formattedDate.split("/")
                return formattedDate
            })
            console.log(dateFormate)
        }
      if (
        recordtype == "" &&
        (transType == "share_transactions" ||
          transType == "subscription_transactions")
      ) {
        console.log("here")
        setPrintmlModel(true);
      } else {
        if (loansel.length > 0) {
          payload = {
            transtype: transType,
            loanno: loansel[0].loanno,
            records: recordtype,
          };
        } else {
          payload = {
            transtype: transType,
            withNotes: checked,
            records: recordtype,
            dr: dateFormate || ""
          };
        }
        // URL to your Django view that generates the PDF
        const receiptUrl = `oasis/member_ledger_statement/${memberid}/`;

        // Fetch the PDF receipt
        const response = await CustomAxios.post(receiptUrl, payload, {
          responseType: "blob",
        });
        setRecordType("");
        setPrintmlModel(false);
        if (response.data) {
          // Create a URL for the PDF blob
          const fileURL = URL.createObjectURL(response.data);

          // Open the PDF in a new window/tab
          const win = window.open(fileURL, "_blank");

          // Optionally, automatically trigger the print dialog in the new window
          win.onload = () => {
            win.focus();
            win.print();
          };
        }
        dispatch(updateDates(null))
      }
    } catch (error) {
      console.error("Error fetching the receipt: ", error);
    } 
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  useEffect(() => {
    if (success == true) {
      setTimeout(() => {
        setSuccess(false);
      }, 5000);
    }
    if (memberSuccess == "Updated Successfully!") {
      setTimeout(() => {
        setMemberSuccess("");
      }, 5000);
    }
    if (corresSuccess == true) {
      setTimeout(() => {
        setCorresSuccess(false);
      }, 5000);
    }
    if (corresDeleted == true) {
      setTimeout(() => {
        setCorresDeleted(false);
      }, 5000);
    }
  }, [success, memberSuccess, corresSuccess, corresDeleted]);

  const handleCancel = (e) => {
    e.preventDefault();
    setPrintmlModel(false);
    setRecordType("");
  };

  // ***************Mobile Number Input Field Formatting***********************

  const formatPhoneNumber = (phoneNumber, type=null) => {
    phoneNumber = phoneNumber.replace(/\D/g, '');

    let formattedNumber = '';
    if (phoneNumber.length > (type === 'telephoneNum' ? 2 : 3)) {
      formattedNumber += phoneNumber.slice(0, (type === 'telephoneNum' ? 2 : 3)) + '-';
      if (phoneNumber.length > (type === 'telephoneNum' ? 6 : 7)) {
        formattedNumber += (type === 'telephoneNum' ? phoneNumber.slice(2, 6) + ' ' + phoneNumber.slice(6, 10) : phoneNumber.slice(3, 7) + ' ' + phoneNumber.slice(7, 11))
      } else {
        formattedNumber += (type === 'telephoneNum' ? phoneNumber.slice(2, 6) : phoneNumber.slice(3, 7))
      }
    } else {
      formattedNumber = phoneNumber;
    }

    return formattedNumber;
  };

  const handleHouseTelChange = (e) => {
    const rawValue = e.target.value.replace(/\D/g, '');

    let formattedValue = formatPhoneNumber(rawValue);
    setHouseTel(formattedValue);
  };

  const handleOfficeTelChange = (e) => {
    const rawValue = e.target.value.replace(/\D/g, '');

    let formattedValue = formatPhoneNumber(rawValue);
    setOfficeTel(formattedValue);
  };

  const handleHpChange = (e) => {
    const rawValue = e.target.value.replace(/\D/g, '');

    let formattedValue = formatPhoneNumber(rawValue);
    setHpNo(formattedValue);
  };

  const handleHpWpChange = (e) => {
    const rawValue = e.target.value.replace(/\D/g, '');
    
    let formattedValue = formatPhoneNumber(rawValue);
    setHpWpNo(formattedValue);
  };

  // *********FUNCTION FOR HANDLE INPUT KEYS***********

  const handleCustomEnterNav = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
  
      const form = e.target.form;
      const elements = Array.from(form.elements);
      const currentIndex = elements.indexOf(e.target);
  
      const moveFocus = (step) => {
        let i = currentIndex + step;
        while (i >= 0 && i < elements.length) {
          const el = elements[i];
          if (el && typeof el.focus === 'function' && !el.disabled && el.tabIndex !== -1) {
            el.focus();
            return;
          }
          i += step;
        }
  
        // If nothing to focus, optionally submit
        if (step > 0) form.requestSubmit();
      };
  
      if (e.shiftKey) {
        moveFocus(-1); // backward
      } else {
        moveFocus(1); // forward
      }
    }
  };

  const handleAutocompleteEnterNav = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      // wait for Autocomplete to select the value before navigating
      setTimeout(() => {
        const form = e.target.form;
        const elements = Array.from(form.elements);
        const currentIndex = elements.indexOf(e.target);
    
        const moveFocus = (step) => {
          let i = currentIndex + step;
          while (i >= 0 && i < elements.length) {
            const el = elements[i];
            if (el && typeof el.focus === 'function' && !el.disabled && el.tabIndex !== -1) {
              el.focus();
              return;
            }
            i += step;
          }
    
          // If nothing to focus, optionally submit
          if (step > 0) form.requestSubmit();
        };
    
        if (e.shiftKey) {
          moveFocus(-1); // backward
        } else {
          moveFocus(1); // forward
        }
      }, 0);
    }
  };

  // const handleDatePickerEnterNav = (e) => {
  //   if (e.key === 'Enter') {
  //     e.preventDefault();
  //     e.stopPropagation(); // Stop MUI DatePicker from opening the calendar popup
  
  //     const form = e.target.form;
  //     const elements = Array.from(form.elements);
  //     const currentIndex = elements.indexOf(e.target);
  
  //     const moveFocus = (step) => {
  //       let i = currentIndex + step;
  //       while (i >= 0 && i < elements.length) {
  //         const el = elements[i];
  //         if (el && typeof el.focus === 'function' && !el.disabled && el.tabIndex !== -1) {
  //           setTimeout(() => {
  //             el.focus();
  //           }, 0);
  //           return;
  //         }
  //         i += step;
  //       }
  
  //       // Optionally submit form if reached end
  //       if (step > 0) form.requestSubmit();
  //     };
  
  //     if (e.shiftKey) {
  //       moveFocus(-1); // Move backward
  //     } else {
  //       moveFocus(1); // Move forward
  //     }
  //   }
  // };

  const handleDatePickerEnterNav = (event) => {
    
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
  
      const form = event.target.form;
      const allElements = Array.from(form.elements);
  
      // Filter real input fields only
      const focusableElements = allElements.filter(
        (el) =>
          el.tagName === 'INPUT' ||
          el.tagName === 'TEXTAREA' ||
          el.tagName === 'SELECT' ||
          (el.tagName === 'BUTTON' && el.type !== 'button') // allow submit/reset
      );
  
      const currentIndex = focusableElements.indexOf(event.target);
      const step = event.shiftKey ? -1 : 1;
      let nextIndex = currentIndex + step;
  
      while (nextIndex >= 0 && nextIndex < focusableElements.length) {
        const nextEl = focusableElements[nextIndex];
        if (nextEl && typeof nextEl.focus === 'function' && !nextEl.disabled) {
          nextEl.focus();
          return;
        }
        nextIndex += step;
      }
  
      // No valid next → submit
      if (step > 0 && nextIndex >= focusableElements.length) {
        form.requestSubmit?.();
      }
    }
  };
  
  

  // **************END OF FUNCTION****************



  // ***************Bank Number Input Field Formatting***********************

  // const bankLengthMapping = {
  //   "ABB": 12,
  //   "ABB-i": 12,
  //   "ABMB": 15,
  //   "ABMB-i": 15,
  //   "AGRO": 16,
  //   "ALRAJ": 15,
  //   "AMBB": 13,
  //   "AMBB-i": 15,
  //   "BAA": 12,
  //   "BBB": 13,
  //   "BIMB": 14,
  //   "BKRMB": 12,
  //   "BMMB": 14,
  //   "BNPP": 11,
  //   "BOC": 15,
  //   "BSN": 16,
  //   "CCBB": 12,
  //   "CIMB": 14,
  //   "CIMB-i": 14,
  //   "CITI": 16,
  //   "DBB": 10,
  //   "HLBB": 13,
  //   "HLBB-i": 13,
  //   "HSBC": 12,
  //   "HSBCa": 12,
  //   "ICBC": 19,
  //   "Journal": 0,
  //   "JPMC": 10,
  //   "KFH": 12,
  //   "MBB": 12,
  //   "MBB-i": 12,
  //   "MBSB": 16,
  //   "MCBM": 10,
  //   "MUFG": 6,
  //   "OCBC": 10,
  //   "OCBC-i": 10,
  //   "PBB": 10,
  //   "PBB-i": 10,
  //   "RHB": 14,
  //   "RHB-i": 14,
  //   "SCB": 12,
  //   "SCB-i": 12,
  //   "SMBC": 8,
  //   "UOB": 11,
  //   "WPM": ""
  // };


  const bankLengthMapping = {
    "ABB                                               ": 12,
    "ABB-i                                             ": 12,
    "ABMB                                              ": 15,
    "ABMB-i                                            ": 15,
    "AGRO                                              ": 16,
    "ALRAJ                                             ": 15,
    "AMBB                                              ": 13,
    "AMBB-i                                            ": 15,
    "BAA                                               ": 12,
    "BBB                                               ": 13,
    "BIMB                                              ": 14,
    "BKRMB                                             ": 12,
    "BMMB                                              ": 14,
    "BNPP                                              ": 11,
    "BOC                                               ": 15,
    "BSN                                               ": 16,
    "CCBB                                              ": 12,
    "CIMB                                              ": 14,
    "CIMB-i                                            ": 14,
    "CITI                                              ": 16,
    "DBB                                               ": 10,
    "HLBB                                              ": 13,
    "HLBB-i                                            ": 13,
    "HSBC                                              ": 12,
    "HSBCa                                             ": 12,
    "ICBC                                              ": 19,
    "Journal                                           ": 0,
    "JPMC                                              ": 10,
    "KFH                                               ": 12,
    "MBB                                               ": 12,
    "MBB-i                                             ": 12,
    "MBSB                                              ": 16,
    "MCBM                                              ": 10,
    "MUFG                                              ": 6,
    "OCBC                                              ": 10,
    "OCBC-i                                            ": 10,
    "PBB                                               ": 10,
    "PBB-i                                             ": 10,
    "RHB                                               ": 14,
    "RHB-i                                             ": 14,
    "SCB                                               ": 12,
    "SCB-i                                             ": 12,
    "SMBC                                              ": 8,
    "UOB                                               ": 11,
    "WPM                                               ": ""
  };

  const getBankLength = (bank) => {
    const length = bankLengthMapping[bank];
    if (length !== undefined) {
      return length;
    } else {
      // console.log(`Bank '${bank}' not found in mapping`);
      return null;
    }
  };

  const getMaskForLength = (length) => {
    if (length === null || length === 0) {
      return ''; // No mask for null or zero length
    }
    let mask = '';
    for (let i = 1; i <= length; i++) {
      mask += '9';
      if (i % 4 === 0 && i !== length) {
        mask += ' ';
      }
    }
    return mask;
  };

  // getBankLength(bank)

  // useEffect(() => {
  //   getBankLength(bank)
  // }, [bank]);
  

  const formatBankAccNumber = (accountNumber) => {
    accountNumber = accountNumber.replace(/\D/g, '');
    let formattedNumber = '';
    for (let i = 0; i < accountNumber.length; i += 4) {
      if (i > 0) {
        formattedNumber += ' ';
      }
      formattedNumber += accountNumber.slice(i, i + 4);
    }
    return formattedNumber;
  };

  const handleAccountNumberChange = (e) => {
    const formattedAccNo = formatBankAccNumber(e.target.value);
    setAccNo(formattedAccNo);
  };

  // ********************************************************************************

  return (
    <Box
      style={{ backgroundColor: "#EFF4F0", marginTop: "40px" }}
      sx={{ minHeight: isMobile && "100vh", height: "100%", width: "100%" }}
    >
      {/* <LinkHeader/> */}
      {tableLoader ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            height: "100%",
          }}
        >
          {/* Circular loader */}
          <CircularProgress size={50} color="success" sx={{ marginBottom: 2 }} />

          {/* Information text */}
          <Typography variant="h6" sx={{ color: "gray" }}>
            Loading data, please wait...
          </Typography>
        </Box>
      )
        : (
          <Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                height: { sm: "initial" },
                padding: "0px 20px 0px 20px",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  top: "72px",
                  left: "304px",
                  padding: "4px 0px 4px 0px",
                  display: "flex",
                  gap:"80px",
                  // justifyContent: "space-between",
                  borderBottom: "1px solid #CBD5E1",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    maxWidth: "200px",
                    height: "48px",
                    padding: "8px 0px 8px 0px",
                    gap: "12px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ width: "32px", height: "32px" }}>
                    <GroupsOutlinedIcon
                      sx={{ width: "32px", height: "32px", color: theme.palette.primary.main }}
                    />
                  </Box>
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontSize: "20px",
                      fontWeight: "600",
                      lineHeight: "28px",
                      color: theme.palette.primary.main,
                    }}
                  >
                    Member Details
                  </Typography>
                </Box>

                {
                  response?.response !== "Registration Successful!" &&
                  <form>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                      <MuiAutocomplete
                        labelId="select-search-label"
                        id="select-search"
                        value={selectedFilter}
                        onChange={handleFilterChange}
                        onKeyDown={handleCustomEnterNav}
                        options={memberFilterArray.map(
                          (option) => option.code
                        )}
                        getOptionLabel={(option) =>
                          memberFilterArray.find(
                            (memOption) => memOption.code === option
                          )?.name || ""
                        }
                        label="Select Filter"
                        autoCompleteStyle={{ width: '200px' }}
                      />
                      <MuiSearchBar
                        handleEnter={handleEnter}
                        search={searchMember}
                        setSearch={setSearchMember}
                        placeholder="MNo / Member Name / MyKAD / NRIC/ Estate"
                      />
                    </Box>
                  </form>

                }
                {/* {active=="Member Profile"&&<Button  onClick={searchMemberStatus?()=>clearAllStates():(e)=> handleSignup(e)}  variant="contained"  sx={{maxWidth:"201px",width:"100%",height:"48px",borderRadius:"4px",padding:"12px",display:"flex",gap:"8px",background:"#E7EFE9", textTransform: "none"}}><PersonAddAltOutlinedIcon sx={{width:"24px",height:"24px",color:"#FFFFF"}}/> <Typography sx={{color:"#FFFFFF",fontSize:"16px",fontWeight:"400",lineHeight:"24px",fontFamily:"inter"}}>Add Member</Typography></Button>} */}
              </Box>
              {/* {filteredMemberList.length > 0 && searchMember?.trim() !== "" && (
          <Box
            sx={{
              zIndex: "1",
              zIndex: "200",
              marginBottom: "20px",
              bottom: "100px",
              left: "432px",
              //maxHeight: "700px",
              height: "100%",
              overflow: "auto",
              borderRadius: "10px",
            }}
          >
            {filteredMemberList.map((mem) => (
              <Button
                style={{
                  display: "flex",
                  gap: "16px",
                  padding: "12px 24px",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  background: "#FFF",
                  "&:hover": { zIndex: 2, background: "green" },
                }}
                onClick={(e) => handleFill(e, mem)}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    width: "400px",
                    justifyContent: "flex-start",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "12px",
                      lineHeight: "16px",
                      color: "#101010",
                      textAlign: "left",
                    }}
                  >
                    {mem.memberid}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "600",
                      fontSize: "16px",
                      lineHeight: "24px",
                      color: "#101010",
                      textAlign: "left",
                    }}
                  >
                    {mem.membername}
                  </Typography>
                  <Box sx={{ display: "flex", gap: "12px" }}>
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "12px",
                        lineHeight: "16px",
                        color: "#101010",
                        textAlign: "left",
                      }}
                    >
                      {mem.newicno !== "null" && mem.oldicno !== "null"
                        ? `NRC (New):${mem.newicno}`
                        : `NRC (old):${mem.oldicno}`}
                    </Typography>
                  </Box>
                </Box>
              </Button>
            ))}
          </Box>
        )} */}

              {filteredMemberList.length > 0 && searchMember?.trim() !== "" && (
                <TableContainer component={Paper} sx={{ maxHeight: '80vh', overflow: 'auto' }}>
                  <Table sx={{ tableLayout: 'fixed', minWidth: '100%' }}>
                    <TableHead>
                      <TableRow sx={{
                        position: 'sticky',
                        top: 0,
                        backgroundColor: '#fff',
                        zIndex: 1, // ensures the header stays above the table body
                      }}>
                        <TableCell style={{ fontWeight: 'bold', width: '60px', height: '10px', padding: '4px' }}>MNo
                          <TextField value={columnFilters.memberid} onChange={(e) => handleColumnFilter('memberid', e.target.value)} size="small" sx={{ width: '90%', '& .MuiOutlinedInput-input': { fontWeight: 'normal', color: '#0072ff' } }} />
                        </TableCell>
                        <TableCell style={{ fontWeight: 'bold', width: '310px', height: '10px', padding: '4px' }}>Name
                          <TextField value={columnFilters.membername} onChange={(e) => handleColumnFilter('membername', e.target.value)} size="small" sx={{ width: '90%', '& .MuiOutlinedInput-input': { fontWeight: 'normal', color: '#0072ff' } }} />
                        </TableCell>
                        <TableCell style={{ fontWeight: 'bold', width: '150px', height: '10px', padding: '4px' }}>MyKAD
                          <TextField value={columnFilters.newicno} onChange={(e) => handleColumnFilter('newicno', e.target.value)} sx={{ width: '90%', '& .MuiOutlinedInput-input': { fontWeight: 'normal', color: '#0072ff' } }} />
                        </TableCell>
                        <TableCell style={{ fontWeight: 'bold', width: '150px', height: '10px', padding: '4px' }}>NRIC
                        <TextField value={columnFilters.oldicno} onChange={(e) => handleColumnFilter('oldicno', e.target.value)} sx={{ width: '90%', '& .MuiOutlinedInput-input': { fontWeight: 'normal', color: '#0072ff' } }} />
                        </TableCell>
                        <TableCell style={{ fontWeight: 'bold', width: '310px', height: '10px', padding: '4px' }}>Estate
                          <TextField value={columnFilters.estate} onChange={(e) => handleColumnFilter('estate', e.target.value)} size="small" sx={{ width: '90%', '& .MuiOutlinedInput-input': { fontWeight: 'normal', color: '#0072ff' } }} />
                        </TableCell>
                        <TableCell style={{ fontWeight: 'bold', width: '100px', height: '10px', padding: '4px' }}>State
                          <TextField value={columnFilters.state} onChange={(e) => handleColumnFilter('state', e.target.value)} size="small" sx={{ width: '90%', '& .MuiOutlinedInput-input': { fontWeight: 'normal', color: '#0072ff' } }} />
                        </TableCell>
                        <TableCell style={{ fontWeight: 'bold', width: '100px', height: '10px', padding: '4px' }}>Share Bal.</TableCell>
                        <TableCell style={{ fontWeight: 'bold', width: '100px', height: '10px', padding: '4px' }}>Subscription Bal.</TableCell>
                        <TableCell style={{ fontWeight: 'bold', width: '100px', height: '10px', padding: '4px' }}>SD Bal.</TableCell>
                        <TableCell style={{ fontWeight: 'bold', width: '100px', height: '10px', padding: '4px' }}>Loan Bal.</TableCell>
                        <TableCell style={{ fontWeight: 'bold', width: '100px', height: '10px', padding: '4px' }}>Bonus</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {/* sx={{background: "#FFF","&:hover": { zIndex: 2, background: "green" }}} */}
                      {columnFilteredMemberList.length > 0 ? (
                        columnFilteredMemberList.map((row, ind) => (
                          <TableRow key={ind} onClick={(e) => handleFill(e, row, ind)} sx={{ background: selectedRow === ind ? '#d3f9d8' : 'inherit', transition: 'background-color 0.5s ease', "&:hover": { zIndex: 2, background: '#d3f9d8' } }}>
                            <TableCell style={{ padding: '2px', fontWeight: 'bold' }}>{row.memberid}</TableCell>
                            <TableCell style={{ padding: '2px', fontWeight: 'bold' }}>{row.membername}</TableCell>
                            <TableCell style={{ padding: '2px', fontWeight: 'bold' }}>{row.newicno}</TableCell>
                            <TableCell style={{ padding: '2px', fontWeight: 'bold' }}>{row.oldicno}</TableCell>
                            <TableCell style={{ padding: '2px', fontWeight: 'bold' }}>{row.estate}</TableCell>
                            <TableCell style={{ padding: '2px', fontWeight: 'bold' }}>{row.state}</TableCell>
                            <TableCell style={{ padding: '2px', fontWeight: 'bold' }}>{parseInt(row.sharebalance).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</TableCell>
                            <TableCell style={{ padding: '2px', fontWeight: 'bold' }}>{parseInt(row.subscriptionbalance).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</TableCell>
                            <TableCell style={{ padding: '2px', fontWeight: 'bold' }}>{parseInt(row.sdbalance).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</TableCell>
                            <TableCell style={{ padding: '2px', fontWeight: 'bold' }}>{parseInt(row.loanbalance).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</TableCell>
                            <TableCell style={{ padding: '2px', fontWeight: 'bold' }}>{parseInt(row.bonus).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={4} align="center">
                            No results found
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Box>
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                  height: { sm: "initial", padding: "4px 20px 4px 20px" },
                  width: "100%",
                  backgroundColor:"#ffe4c4"
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "row", gap: "50px" }}>
                  <Box
                    sx={{
                      Width: "347px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#101010",
                      }}
                    >
                      MNo
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "700",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#101010",
                      }}
                    >
                      : {memberNo}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      Width: "347px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#101010",
                      }}
                    >
                      Member Name
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "700",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#101010",
                      }}
                    >
                      : {memberName}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      Width: "347px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#101010",
                      }}
                    >
                      Age
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "700",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#101010",
                      }}
                    >
                      : {age}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      Width: "347px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#101010",
                      }}
                    >
                      MyKad
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "700",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#101010",
                      }}
                    >
                      : {newNric}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      Width: "347px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#101010",
                      }}
                    >
                      NRIC
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "700",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#101010",
                      }}
                    >
                      : {oldNric}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      Width: "347px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#101010",
                      }}
                    >
                      Estate
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "700",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#101010",
                      }}
                    >
                      : {estate}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      Width: "347px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#101010",
                      }}
                    >
                      Oasis Mno
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "700",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#101010",
                      }}
                    >
                      : {oasisId}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Grid container sx={{ height: { sm: "initial" } }}>
                {/* <Box sx={{position:"absolute",padding:"25px",color:"#E7EFE9"}} component={RouterLink}  to="/executive_summary"><ArrowBackIcon/></Box> */}
                {/* <Grid item xs={12} sm={7} className='login-bg-primary' sx={[isMobile&&{backgroundColor:"#f2f6fc"},{display: "flex", alignItems: "center", justifyContent: "center"}]}>
                  <Box component='img' sx={{width: { xs: "100%", sm: "300px", md:"500px",lg:"initial" }}} src={signupBanner} />
              </Grid> */}
                {printmlModel && (
                  <Dialog
                    visible={printmlModel}
                    style={{
                      width: "450px",
                      boxShadow: "0px 0px 34px 0px rgba(100, 116, 139, 0.50)",
                      background: "#f2f6fc",
                      borderRadius: "0px",
                    }}
                    className="custombar1"
                    draggable={false}
                    position="center"
                    modal={false}
                    closable={false}
                    resizable={false}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px",
                        padding: "16px",
                      }}
                    >
                      <Typography
                        sx={{
                          alignSelf: "stretch",
                          width: "100%",
                          fontFamily: "inter",
                          fontSize: "16px",
                          fontStyle: "inter",
                          fontWeight: "400",
                          lineHeight: "24px",
                          color: "#288d2c",
                        }}
                      >
                        Please choose an option and click print
                      </Typography>
                      <div
                        className="flex align-items-center"
                        style={{ display: "flex", alignItems: "center", gap: "8px" }}
                      >
                        <RadioButton
                          inputId="Option1"
                          value="detailed"
                          style={{ display: "flex", alignItems: "center" }}
                          onChange={(e) => setRecordType("existing without notes")}
                          checked={recordtype === "existing without notes"}
                        />
                        <label htmlFor="Option1" className="ml-2">
                          Print Existing Ledger (Without Notes)
                        </label>
                      </div>
                      <div
                        className="flex align-items-center"
                        style={{ display: "flex", alignItems: "center", gap: "8px" }}
                      >
                        <RadioButton
                          inputId="Option1"
                          value="detailed"
                          style={{ display: "flex", alignItems: "center" }}
                          onChange={(e) => setRecordType("existing with notes")}
                          checked={recordtype === "existing with notes"}
                        />
                        <label htmlFor="Option1" className="ml-2">
                          Print Existing Ledger (With Notes)
                        </label>
                      </div>
                      <div
                        className="flex align-items-center"
                        style={{ display: "flex", alignItems: "center", gap: "8px" }}
                      >
                        <RadioButton
                          inputId="Option1"
                          value="detailed"
                          style={{ display: "flex", alignItems: "center" }}
                          onChange={(e) => setRecordType("earlier 1619")}
                          checked={recordtype === "earlier 1619"}
                        />
                        <label htmlFor="Option1" className="ml-2">
                          Print Earlier Ledger (From 2016 - 2019)
                        </label>
                      </div>
                      <div
                        className="flex align-items-center"
                        style={{ display: "flex", alignItems: "center", gap: "8px" }}
                      >
                        <RadioButton
                          inputId="Option1"
                          value="detailed"
                          style={{ display: "flex", alignItems: "center" }}
                          onChange={(e) => setRecordType("earlier 1215")}
                          checked={recordtype === "earlier 1215"}
                        />
                        <label htmlFor="Option1" className="ml-2">
                          Print Earlier Ledger (From 2012 - 2015)
                        </label>
                      </div>

                      {transType == "share_transactions" && (
                        <>
                          <div
                            className="flex align-items-center"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <RadioButton
                              inputId="Option1"
                              value="detailed"
                              style={{ display: "flex", alignItems: "center" }}
                              onChange={(e) => setRecordType("earlier 0911")}
                              checked={recordtype === "earlier 0911"}
                            />
                            <label htmlFor="Option1" className="ml-2">
                              Print Earlier Ledger (From 2009 - 2011)
                            </label>
                          </div>
                          <div
                            className="flex align-items-center"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <RadioButton
                              inputId="Option1"
                              value="detailed"
                              style={{ display: "flex", alignItems: "center" }}
                              onChange={(e) => setRecordType("earlier 08")}
                              checked={recordtype === "earlier 08"}
                            />
                            <label htmlFor="Option1" className="ml-2">
                              Print Earlier Ledger (Till Year 2008)
                            </label>
                          </div>
                        </>
                      )}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          type="submit"
                          variant="contained"
                          disabled={
                            transType == "loan_transactions" && selected.length == 0
                              ? true
                              : false
                          }
                          onClick={handleFetchAndPrintReceipt}
                          sx={{
                            width: "50px",
                            display: "flex",
                            flexShrink: 0,
                            fontSize: "16px",
                            padding: "12px",
                            height: "36px",
                          }} // Adjust width as needed
                        >
                          Print
                        </Button>
                        <Button
                          variant="contained"
                          disabled={
                            transType == "loan_transactions" && selected.length == 0
                              ? true
                              : false
                          }
                          onClick={(e) => handleCancel(e)}
                          sx={{
                            width: "75px",
                            display: "flex",
                            flexShrink: 0,
                            fontSize: "16px",
                            padding: "12px",
                            height: "36px",
                          }} // Adjust width as needed
                        >
                          Cancel
                        </Button>
                      </Box>
                    </Box>
                  </Dialog>
                )}
                {response?.response == "Registration Successful!" ? (
                  <Box
                    sx={{
                      padding: "30px",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={5}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        height: "100%",
                      }}
                    >
                      {success == true && (
                        <Box
                          sx={{
                            maxWidth: "580px",
                            width: "100%",
                            height: "84px",
                            border: "2px solid #E7EFE9",
                            background: "#DCFCE7",
                            borderRadius: "4px",
                            display: "flex",
                            gap: "16px",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "absolute",
                            top: "-24px",
                            zIndex: "2",
                          }}
                        >
                          <IconButton>
                            <DoneIcon
                              onClick={() => setSuccess(false)}
                              sx={{ width: "24px", height: "24px" }}
                            />
                          </IconButton>
                          <Box>
                            <Typography
                              sx={{
                                alignSelf: "stretch",
                                width: "100%",
                                fontFamily: "inter",
                                fontSize: "16px",
                                fontStyle: "inter",
                                fontWeight: "700",
                                lineHeight: "24px",
                                color: "#16A34A",
                              }}
                            >
                              New Member Added Successfully
                            </Typography>
                            <Typography
                              sx={{
                                alignSelf: "stretch",
                                width: "100%",
                                fontFamily: "inter",
                                fontSize: "16px",
                                fontStyle: "inter",
                                fontWeight: "400",
                                lineHeight: "24px",
                                color: "#16A34A",
                              }}
                            >
                              Member ID has been generated for the Member
                            </Typography>
                          </Box>
                          <IconButton>
                            <ClearIcon
                              onClick={() => setSuccess(false)}
                              sx={{ width: "24px", height: "24px" }}
                            />
                          </IconButton>
                        </Box>
                      )}

                      <Box
                        className="login-bg-primary form"
                        sx={[isMobile && { backgroundColor: "#f2f6fc" }]}
                      >
                        <Box
                          sx={{ mb: 1 }}
                          className="fn-h3 fw-600 primary text-center"
                        >
                          {response.response}
                        </Box>
                        <Typography
                          sx={{ textAlign: "left", fontSize: "20px", padding: "10px" }}
                        >
                          Member Name: {response.membername}
                        </Typography>
                        <Typography
                          sx={{ textAlign: "left", fontSize: "20px", padding: "10px" }}
                        >
                          E-Mail:{response.emailid}
                        </Typography>
                        <Typography
                          sx={{ textAlign: "left", fontSize: "20px", padding: "10px" }}
                        >
                          MNo:{response.membership_no}
                        </Typography>
                        <Typography
                          sx={{ textAlign: "left", fontSize: "20px", padding: "10px" }}
                        >
                          Member Id:{response.memberid}
                        </Typography>
                        {/* <Box className='pgh text-center'>MemberName:{response.membername}</Box> */}
                        <Button
                          fullWidth
                          variant="contained"
                          color="primary"
                          sx={{ textTransform: "none" }}
                          onClick={() => setResponse(null)}
                          startIcon={<PersonAddIcon />}
                        >
                          Create More Members
                        </Button>
                      </Box>
                    </Grid>
                  </Box>
                ) : (
                  // <Grid item xs={12} sm={5}  sx={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                  //     <Box className='login-bg-primary form' sx={[isMobile&&{backgroundColor:"#f2f6fc"}]}>
                  //         <form>
                  //             <Box sx={{mb:1}} className='fn-h3 fw-600 primary text-center'>Add member</Box>
                  //             <Box className='pgh-heading fw-600 text-center' style={{}}>Welcome back to Koperasi!</Box>
                  //             <Box className='pgh text-center'>It's simple to add a new member. Just provide their details below.</Box>
                  //             <Box sx={{mt:"30px",mb:4 }}>
                  //                 <Box sx={{mb:4}}>
                  //                     <Box sx={{mb:"12px", color:"#101010"}}>Email ID <span style={{color:"#EF4444"}}>*</span></Box>
                  //                     <MuiInput
                  //                         placeholder="Enter Email ID"disabled={ searchMemberStatus && !editdetails }
                  //                         fullWidth
                  //                         variant="outlined"
                  //                         onChange={(e) => setEmail(e.target.value)}
                  //                         InputProps={{
                  //                             startAdornment: (
                  //                             <InputAdornment position="start">
                  //                                 <AlternateEmailOutlined />
                  //                             </InputAdornment>
                  //                             ),
                  //                         }}
                  //                     />
                  //                 </Box>

                  //                 <Box sx={{ mb: 4 }}>
                  //                     <Box sx={{ mb: '12px', color: '#101010' }}>Member Name <span style={{ color: '#EF4444' }}>*</span></Box>
                  //                     <MuiInput
                  //                         placeholder="Enter Member Name"
                  //                         fullWidth
                  //                         variant="outlined"
                  //                         onChange={(e) => setMemberId(e.target.value)}
                  //                         inputProps={{
                  //                             maxLength: 11,
                  //                             }}
                  //                         InputProps={{
                  //                             startAdornment: (
                  //                                 <InputAdornment position="start">
                  //                                     <PersonOutline />disabled={ searchMemberStatus && !editdetails }
                  //                                 </InputAdornment>
                  //                                 )
                  //                         }}
                  //                     />
                  //                 </Box>
                  //                 <Box sx={{ mb: 4 }}>
                  //                     <Box sx={{ mb: '12px', color: '#101010' }}>Phone Number <span style={{ color: '#EF4444' }}>*</span></Box>
                  //                     <MuiInput
                  //                     placeholder="Enter Phone Number"disabled={ searchMemberStatus && !editdetails }
                  //                     fullWidth
                  //                     variant="outlined"
                  //                     onChange={(e) => setPhoneNumber(e.target.value)}
                  //                     InputProps={{
                  //                         startAdornment: (
                  //                         <InputAdornment position="start">disabled={ searchMemberStatus && !editdetails }
                  //                             <PhoneIphoneOutlined />
                  //                         </InputAdornment>
                  //                         ),
                  //                     }}
                  //                     />
                  //                 </Box>disabled={ searchMemberStatus && !editdetails }

                  //                 <Box sx={{mb:4}}>
                  //                     <Box sx={{mb:"12px", color:"#101010"}}>Password <span style={{color:"#EF4444"}}>*</span></Box>
                  //                     <MuiInput
                  //                         placeholder="Enter Password"
                  //                         fullWidth
                  //                         variant="outlined"
                  //                         type={showPassword ? 'text' : 'password'}
                  //                         onChange={(e) => setPassword(e.target.value)}
                  //                         InputProps={{
                  //                             startAdornment: (
                  //                             <InputAdornment position="start">
                  //                                 <LockOutlined />
                  //                             </InputAdornment>
                  //                             ),
                  //                             endAdornment: (
                  //                             <InputAdornment position="end">
                  //                                 <IconButton onClick={handleTogglePasswordVisibility}>
                  //                                 {showPassword ? <VisibilityOutlined /> : <VisibilityOffOutlined /> }
                  //                                 </IconButton>
                  //                             </InputAdornment>
                  //                             ),
                  //                         }}
                  //                     />
                  //                 </Box>

                  //                 <Button type="submit" fullWidth variant="contained" color="primary" sx={{textTransform:"none"}} onClick={handleSignup} startIcon={<LoginOutlined />}>
                  //                     Add Member
                  //                 </Button>
                  //             </Box>
                  //         </form>
                  //         <Box className='text-center'>
                  //             <Box>
                  //                 <span className='link'>have an account? </span>
                  //                 <Link component={RouterLink} to="/login">
                  //                 Login
                  //                 </Link>
                  //             </Box>
                  //         </Box>
                  //     </Box>
                  // </Grid>
                  <Box
                    sx={{
                      padding: "0px 4px",
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      position: "relative",
                    }}
                  >
                    {memberSuccess == "Updated Successfully!" && (
                      <Box
                        sx={{
                          maxWidth: "580px",
                          width: "100%",
                          height: "84px",
                          border: "2px solid #E7EFE9",
                          background: "#DCFCE7",
                          borderRadius: "4px",
                          display: "flex",
                          gap: "16px",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "absolute",
                          top: "34px",
                          left: "32%",
                          zIndex: "2",
                        }}
                      >
                        <IconButton>
                          <DoneIcon
                            onClick={() => setMemberSuccess("")}
                            sx={{ width: "24px", height: "24px" }}
                          />
                        </IconButton>
                        <Box>
                          <Typography
                            sx={{
                              alignSelf: "stretch",
                              width: "100%",
                              fontFamily: "inter",
                              fontSize: "16px",
                              fontStyle: "inter",
                              fontWeight: "700",
                              lineHeight: "24px",
                              color: "#16A34A",
                            }}
                          >
                            Member Updated Successfully
                          </Typography>
                        </Box>
                        <IconButton>
                          <ClearIcon
                            onClick={() => setMemberSuccess("")}
                            sx={{ width: "24px", height: "24px" }}
                          />
                        </IconButton>
                      </Box>
                    )}
                    {corresSuccess == true && (
                      <Box
                        sx={{
                          maxWidth: "580px",
                          width: "100%",
                          height: "84px",
                          border: "2px solid #E7EFE9",
                          background: "#DCFCE7",
                          borderRadius: "4px",
                          display: "flex",
                          gap: "16px",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "absolute",
                          top: "34px",
                          left: "32%",
                          zIndex: "2",
                        }}
                      >
                        <IconButton>
                          <DoneIcon
                            onClick={() => setCorresSuccess(false)}
                            sx={{ width: "24px", height: "24px" }}
                          />
                        </IconButton>
                        <Box>
                          <Typography
                            sx={{
                              alignSelf: "stretch",
                              width: "100%",
                              fontFamily: "inter",
                              fontSize: "16px",
                              fontStyle: "inter",
                              fontWeight: "700",
                              lineHeight: "24px",
                              color: "#16A34A",
                            }}
                          >
                            Correspondence Address Updated Successfully
                          </Typography>
                        </Box>
                        <IconButton>
                          <ClearIcon
                            onClick={() => setCorresSuccess(false)}
                            sx={{ width: "24px", height: "24px" }}
                          />
                        </IconButton>
                      </Box>
                    )}
                    {corresDeleted == true && (
                      <Box
                        sx={{
                          maxWidth: "580px",
                          width: "100%",
                          height: "84px",
                          border: "2px solid #ce0a0a",
                          background: "#ff080891",
                          borderRadius: "4px",
                          display: "flex",
                          gap: "16px",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "absolute",
                          top: "34px",
                          left: "32%",
                          zIndex: "2",
                        }}
                      >
                        <IconButton>
                          <DoneIcon
                            onClick={() => setCorresSuccess(false)}
                            sx={{ width: "24px", height: "24px" }}
                          />
                        </IconButton>
                        <Box>
                          <Typography
                            sx={{
                              alignSelf: "stretch",
                              width: "100%",
                              fontFamily: "inter",
                              fontSize: "16px",
                              fontStyle: "inter",
                              fontWeight: "700",
                              lineHeight: "24px",
                              color: "#fff",
                            }}
                          >
                            Correspondence Address Deleted Successfully
                          </Typography>
                        </Box>
                        <IconButton>
                          <ClearIcon
                            onClick={() => setCorresSuccess(false)}
                            sx={{ width: "24px", height: "24px" }}
                          />
                        </IconButton>
                      </Box>
                    )}
                    {/* <Box sx={{maxWidth:"400px",width:"100%",gap:"8px",display:"flex",flexDirection:"column",position:"relative"}} > */}

                    {/* <Box sx={{display:"flex",gap:"16px",padding:"12px 24px",alignItems:"center",background:"#E2E8F0"}}> */}
                    {/* <Box component="img" src={selectedImage} sx={{width:"40px",maxHeight:"40px",borderRadius:"20px",objectFit:"cover"}}></Box> */}
                    {/* <Box sx={{display:"flex",flexDirection:"column",gap:""}}>
                                  <Typography sx={{fontFamily:"inter",fontWeight:"400",fontSize:"12px",lineHeight:"16px",color:"#101010"}}>{memberNo}</Typography>
                                  <Typography sx={{fontFamily:"inter",fontWeight:"600",fontSize:"16px",lineHeight:"24px",color:"#101010"}}>{memberName}</Typography>
                                  <Box sx={{display:"flex",gap:"12px"}}>
                                  <Typography sx={{fontFamily:"inter",fontWeight:"400",fontSize:"12px",lineHeight:"16px",color:"#101010"}}>{newNric!==""&&oldNric!==""?`NRC (New):${newNric}`:`NRC (New):${newNric}`}</Typography>
                                  </Box>
                              </Box> */}
                    {/* <div className="card">
                                  <DataTable value={memberList}  scrollable scrollHeight="700px" 
                                  virtualScrollerOptions={{ lazy: true, onLazyLoad: loadCarsLazy, itemSize: 46, delay: 200, showLoader: true, loading: lazyLoading, loadingTemplate }}>
                                      {columnVisible.filter(col => col.visible).map(col => <Column className="custom-column-style"    body={col.body} style={col.style} />)}
                                  </DataTable>
                                  <Button onClick={(e)=>handlePage(e) } sx={{width:"100%"}}>Load more</Button>
                              </div> */}

                    {/* </Box> */}
                    {/* </Box> */}
                    <Box
                      sx={{
                        display: "flex",
                        gap: "4px",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          borderBottom: "1px solid #CBD5E1",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <Box
                            sx={{
                              display: "flex",
                              alignSelf: "stretch",
                              padding: "10px",
                              background: active == "Member Profile" ? "#288d2c" : "#EFF4F0",
                              borderBottom:
                                active == "Member Profile"
                                  ? "2px solid #288d2c"
                                  : "1px solid #CBD5E1",
                              cursor: "pointer",
                              transition: "all 0.7s ease",
                              "&:hover": {
                                background: "#29ab2f",
                                "& .MuiTypography-root": {
                                  color: "#fff", // Change the text color on hover
                                },
                              },
                            }}
                            onClick={() => setActive("Member Profile")}
                          >
                            <Typography
                              sx={{
                                fontFamily: "inter",
                                fontSize: "16px",
                                fontWeight: "700",
                                lineHeight: "24px",
                                color:
                                  active == "Member Profile" ? "#fff" : "#64748B",
                              }}
                            >
                              Member Profile
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              alignSelf: "stretch",
                              padding: "10px",
                              background: active == "Nominee Information" ? "#288d2c" : "#EFF4F0",
                              borderBottom:
                                active == "Nominee Information"
                                  ? "2px solid #288d2c"
                                  : "1px solid #CBD5E1",
                              cursor: "pointer",
                              transition: "all 0.7s ease",
                              "&:hover": {
                                background: "#29ab2f",
                                "& .MuiTypography-root": {
                                  color: "#fff", // Change the text color on hover
                                },
                              },
                            }}
                            onClick={() => setActive("Nominee Information")}
                          >
                            <Typography
                              sx={{
                                fontFamily: "inter",
                                fontSize: "16px",
                                fontWeight: "700",
                                lineHeight: "24px",
                                color:
                                  active == "Nominee Information"
                                    ? "#fff"
                                    : "#64748B",
                              }}
                            >
                              Nominee Information
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              alignSelf: "stretch",
                              padding: "10px",
                              background: active == "Transaction History" ? "#288d2c" : "#EFF4F0",
                              borderBottom:
                                active == "Transaction History"
                                  ? "2px solid #288d2c"
                                  : "1px solid #CBD5E1",
                              cursor: "pointer",
                              transition: "all 0.7s ease",
                              "&:hover": {
                                background: "#29ab2f",
                                "& .MuiTypography-root": {
                                  color: "#fff", // Change the text color on hover
                                },
                              },
                            }}
                            onClick={() => setActive("Transaction History")}
                          >
                            <Typography
                              sx={{
                                fontFamily: "inter",
                                fontSize: "16px",
                                fontWeight: "700",
                                lineHeight: "24px",
                                color:
                                  active == "Transaction History"
                                    ? "#fff"
                                    : "#64748B",
                              }}
                            >
                              Transaction History
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              alignSelf: "stretch",
                              padding: "10px",
                              background: active == "Certificate Details" ? "#288d2c" : "#EFF4F0",
                              borderBottom:
                                active == "Certificate Details"
                                  ? "2px solid #288d2c"
                                  : "1px solid #CBD5E1",
                              cursor: "pointer",
                              transition: "all 0.7s ease",
                              "&:hover": {
                                background: "#29ab2f",
                                "& .MuiTypography-root": {
                                  color: "#fff", // Change the text color on hover
                                },
                              },
                            }}
                            onClick={() => setActive("Certificate Details")}
                          >
                            <Typography
                              sx={{
                                fontFamily: "inter",
                                fontSize: "16px",
                                fontWeight: "700",
                                lineHeight: "24px",
                                color:
                                  active == "Certificate Details"
                                    ? "#fff"
                                    : "#64748B",
                              }}
                            >
                              Certificate Details
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              alignSelf: "stretch",
                              padding: "10px",
                              background: active == "Guarantor Details" ? "#288d2c" : "#EFF4F0",
                              
                              borderBottom:
                                active == "Guarantor Details"
                                  ? "2px solid #288d2c"
                                  : "1px solid #CBD5E1",
                              cursor: "pointer",
                              transition: "all 0.7s ease",
                              "&:hover": {
                                background: "#29ab2f",
                                "& .MuiTypography-root": {
                                  color: "#fff", // Change the text color on hover
                                },
                              },
                            }}
                            onClick={() => setActive("Guarantor Details")}
                          >
                            <Typography
                              sx={{
                                fontFamily: "inter",
                                fontSize: "16px",
                                fontWeight: "700",
                                lineHeight: "24px",
                                color:
                                  active == "Guarantor Details"
                                    ? "#fff"
                                    : "#64748B",
                              }}
                            >
                              Guarantor Details
                            </Typography>
                          </Box>
                        </Box>
                        

                      </Box>
                      {active == "Member Profile" && (
                        <Box
                          sx={{
                            //maxHeight: editdetails ? "630px" : "700px",
                            height: "100%",
                            // overflow: "auto",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <form
                            ref={formRef}
                            onSubmit={(e) => handleSignup(e)}
                            style={{}}
                          >
                            {/* NEW FIRST SECTION GRID FOR BASIC DETAILS */}
                            <Grid container spacing={1}>
                              <Grid item xs={10.4}>
                                <Box
                                  sx={{ display: "flex", width: "100%", gap: "10px", marginTop: '4px' }}
                                >
                                  {searchMemberStatus && <Box sx={{ maxWidth: "100px", width: "100%" }}>
                                    <MuiInput
                                      type="number"
                                      label="MNo"
                                      variant="outlined"
                                      disabled={true}
                                      value={memberNo}
                                      onChange={(e) => handleMemberChange(e)}
                                      onKeyDown={handleCustomEnterNav}
                                      sx={{
                                        width: "100%",
                                        backgroundColor: "#FFF",
                                        fontSize: "14px",
                                        color:
                                          searchMemberStatus && !editdetails
                                            ? "#101010"
                                            : "#101010",
                                      }}
                                    />
                                  </Box>}
                                  <Box
                                    sx={{
                                      minWidth: "600px",
                                      maxWidth: "650px",
                                      width: "100%",
                                    }}
                                  >
                                    {/* <Typography sx={{ alignSelf: "stretch", width: "200px", fontFamily: "inter", fontSize: "16px", fontStyle: "inter", fontWeight: "400", lineHeight: "24px" ,color:"#101010"}}>Member Name<Typography component="span" sx={{color:"red"}}>*</Typography></Typography> */}
                                    <MuiInput
                                      label="Member Name"
                                      variant="outlined"
                                      disabled={searchMemberStatus && !editdetails}
                                      required
                                      value={memberName}
                                      onChange={(e) => handleNameChange(e)}
                                      onKeyDown={handleCustomEnterNav}
                                      sx={{
                                        width: "100%",
                                        backgroundColor: "#FFF",
                                        fontSize: "14px",
                                        color: "#101010",
                                      }}
                                    />
                                    {membererror !== "" && memberName?.trim() == "" && (
                                      <Typography
                                        sx={{
                                          alignSelf: "stretch",
                                          fontFamily: "inter",
                                          fontSize: "16px",
                                          fontStyle: "normal",
                                          fontWeight: "400",
                                          lineHeight: "24px",
                                          color: "red",
                                        }}
                                      >
                                        {membererror}
                                      </Typography>
                                    )}
                                  </Box>
                                  <Box sx={{ maxWidth: "60px", width: "100%" }}>
                                      {/* NEED TO WRITE LOGICS FOR AGE - US_PENDING */}
                                      <MuiInput
                                        label="Age"
                                        variant="outlined"
                                        disabled={true}
                                        value={age}
                                        onKeyDown={handleCustomEnterNav}
                                        sx={{
                                          width: "100%",
                                          backgroundColor: "#FFF",
                                          fontSize: "14px",
                                          '& .MuiOutlinedInput-input': { color: 'red' }
                                        }}
                                        
                                      />
                                  </Box>
                                  <Box sx={{ maxWidth: "180px", width: "100%" }}>
                                      <MuiInput
                                        label="MyKAD *"
                                        variant="outlined"
                                        disabled={searchMemberStatus && !editdetails}
                                        value={newNric}
                                        mask="999999-99-9999"
                                        onChange={(e) => handleNewicnoChange(e)}
                                        onKeyDown={handleCustomEnterNav} // Keep this as needed for key navigation
                                        sx={{
                                          width: "100%",
                                          backgroundColor: "#FFF",
                                          fontSize: "14px",
                                          color: "#101010"
                                        }}
                                      />
                                      {nricerror !== "" &&
                                        !newNric?.trim() &&
                                        !oldNric?.trim() &&
                                        !newNric?.trim() &&
                                        !oldNric?.trim() && (
                                          <Typography
                                            sx={{
                                              alignSelf: "stretch",
                                              fontFamily: "inter",
                                              fontSize: "16px",
                                              fontStyle: "normal",
                                              fontWeight: "400",
                                              lineHeight: "24px",
                                              color: "red",
                                            }}
                                          >
                                            {nricerror}
                                          </Typography>
                                        )}
                                      {mykadDateError !== "" && (
                                        <Typography
                                          sx={{
                                            alignSelf: "stretch",
                                            fontFamily: "inter",
                                            fontSize: "14px",
                                            fontStyle: "normal",
                                            fontWeight: "400",
                                            lineHeight: "20px",
                                            color: "red",
                                            mt: 0.5,
                                          }}
                                        >
                                          {mykadDateError}
                                        </Typography>
                                      )}
                                    </Box>
                                    <Box sx={{ maxWidth: "180px", width: "100%" }}>
                                      <MuiInput
                                        label="Old IC No / BC"
                                        variant="outlined"
                                        disabled={searchMemberStatus && !editdetails}
                                        value={oldNric}
                                        onChange={(e) => setOldNric(e.target.value)}
                                        onKeyDown={handleCustomEnterNav}
                                        sx={{
                                          width: "100%",
                                          backgroundColor: "#FFF",
                                          fontSize: "14px",
                                          color: "#101010",
                                        }}
                                      />
                                    </Box>
                                    <Box sx={{ maxWidth: "150px", width: "100%" }}>
                                      <MuiInput
                                        label="TIN"
                                        value={tinNo}
                                        variant="outlined"
                                        disabled={searchMemberStatus && !editdetails}
                                        // disabled={true}
                                        onChange={(e) => setTinNo(e.target.value)}
                                        onKeyDown={handleCustomEnterNav}
                                        sx={{
                                          width: "100%",
                                          backgroundColor: "#FFF",
                                          fontSize: "14px",
                                          color: "#101010",
                                        }}
                                      />
                                    </Box>
                                  
                                </Box>
                                {/* <Box
                                  sx={{
                                    display: "flex",
                                    width: "100%",
                                    gap: "20px",
                                    marginTop: 1,
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Box sx={{ display: 'flex', gap: '20px' }}>
                                    
                                    
                                  </Box>
                                </Box> */}
                                <Box sx={{
                                  display: "flex",
                                  width: "100%",
                                  gap: "940px",
                                }}>
                                  <Typography
                                    sx={{
                                      fontFamily: "inter",
                                      fontWeight: "500",
                                      fontSize: "18px",
                                      // lineHeight: "28px",
                                      color: "#64748B",
                                    }}
                                  >
                                    Permanent Address
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: "inter",
                                      fontWeight: "500",
                                      fontSize: "18px",
                                      // lineHeight: "28px",
                                      color: "#64748B",
                                    }}
                                  >
                                    Status
                                  </Typography>
                                </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    width: "100%",
                                    gap: "4px",
                                  }}
                                >
                                  <Box sx={{ width:"100%",maxWidth: "565px" }}>

                                    <MuiInput
                                      label="Address 1"
                                      variant="outlined"
                                      disabled={searchMemberStatus && !editdetails}
                                      value={adress1}
                                      onChange={(e) => setAdress1(e.target.value)}
                                      onKeyDown={handleCustomEnterNav}
                                      InputProps={{
                                        maxLength: 50,
                                        style: {
                                          whiteSpace: "nowrap",
                                        },
                                      }}
                                      sx={{
                                        maxWidth: "560px",
                                        width: "100%",
                                        // marginTop: 1,
                                        backgroundColor: "#FFF",
                                        fontSize: "5px",
                                        color: "#101010",
                                      }}
                                    />
                                    <MuiInput
                                      label="Address 2"
                                      variant="outlined"
                                      disabled={searchMemberStatus && !editdetails}
                                      value={adress2}
                                      onChange={(e) => setAdress2(e.target.value)}
                                      onKeyDown={handleCustomEnterNav}
                                      InputProps={{
                                        maxLength: 50,
                                        style: {
                                          whiteSpace: "nowrap",
                                        },
                                      }}
                                      sx={{
                                        maxWidth: "560px",
                                        width: "100%",
                                        marginTop: 1,
                                        backgroundColor: "#FFF",
                                        fontSize: "5px",
                                        color: "#101010",
                                      }}
                                    />
                                    <MuiInput
                                      label="Address 3"
                                      variant="outlined"
                                      disabled={searchMemberStatus && !editdetails}
                                      value={adress3}
                                      onChange={handlePermanentAddress3Change}
                                      onKeyDown={handleCustomEnterNav}
                                      InputProps={{
                                        maxLength: 50,
                                        style: {
                                          whiteSpace: "nowrap",
                                        },
                                      }}
                                      sx={{
                                        maxWidth: "560px",
                                        width: "100%",
                                        marginTop: 1,
                                        backgroundColor: "#FFF",
                                        fontSize: "5px",
                                        color: "#101010",
                                      }}
                                    />
                                    <Box
                                      sx={{
                                        display: "flex",
                                        gap: "17px",
                                        flexDirection: "row",
                                        maxWidth: "560px",
                                        width: "100%",
                                        marginTop: 1
                                      }}
                                    >
                                      <MuiAutocomplete
                                        labelId="select-state-label"
                                        id="select-state"
                                        disabled={searchMemberStatus && !editdetails}
                                        value={adress4}
                                        onChange={(event, newValue) => {
                                          setAdress4(newValue);
                                        }}
                                        onKeyDown={handleCustomEnterNav}
                                        options={states.sort()}
                                        label="Select State"
                                        autoCompleteStyle={{ width: "770px", marginTop: "0px" }}
                                        textFieldStyle={{
                                          width: "365px",
                                          fontSize: "8px",
                                          fontWeight: "400",
                                          color:
                                            searchMemberStatus && !editdetails
                                              ? "#242424"
                                              : "#101010",
                                        }}
                                      />
                                      <Box sx={{ width: "40%" }}>
                                        
                                        <MuiInput
                                          label="Post Code"
                                          variant="outlined"
                                          disabled={searchMemberStatus && !editdetails}
                                          value={postal}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*$/.test(value)) {
                                              setPostal(value);
                                            }
                                          }}
                                          onKeyDown={handleCustomEnterNav}
                                          inputProps={{
                                            maxLength: 5,
                                            pattern: "[0-9]*",
                                          }}
                                          style={{
                                            width: "179px",
                                            backgroundColor: "#FFF",
                                            fontSize: "10px",
                                            color:
                                              searchMemberStatus && !editdetails
                                                ? "#242424"
                                                : "#101010",
                                          }}
                                        />
                                      </Box>
                                    </Box>
                                    <Box sx={{ display: 'flex' }}>
                                      <Box sx={{ maxWidth: "270px", width: "100%" }}>
                                        {/* <Typography sx={{ alignSelf: "stretch", width: "200px", fontFamily: "inter", fontSize: "16px", fontStyle: "inter", fontWeight: "400", lineHeight: "24px" ,color:"#101010"}}>Email ID</Typography> */}
                                        <FormControlLabel
                                            control={<Checkbox color="success" />}
                                            label="No Mailer"
                                            disabled={searchMemberStatus && !editdetails}
                                            checked={nomailer}
                                            onChange={(e) => setNomailer(!nomailer)}
                                            onKeyDown={handleCustomEnterNav}
                                            sx={{ paddingLeft: '5px',
                                            }}
                                          />
                                      </Box>
                                      <Box sx={{ maxWidth: "270px", width: "100%" }}>
                                        {/* <Typography sx={{ alignSelf: "stretch", width: "200px", fontFamily: "inter", fontSize: "16px", fontStyle: "inter", fontWeight: "400", lineHeight: "24px" ,color:"#101010"}}>Password<Typography component="span" sx={{color:"red"}}>*</Typography></Typography> */}
                                        <FormControlLabel
                                            control={<Checkbox color="success" />}
                                            label="Non-Benefit Member"
                                            disabled={searchMemberStatus && !editdetails}
                                            checked={nonbenifit}
                                            onKeyDown={handleCustomEnterNav}
                                            onChange={(e) => setNonBenefit(!nonbenifit)}
                                            sx={{ paddingLeft: '5px' }}
                                          />
                                      </Box>
                                    </Box>
                                  </Box>
                                  {/* SUPRESSING CORRESPONDANCE ADDRESS FEATURE */}
                                  <Box >
                                    <Box sx={{ display: "flex", gap: "8px"}}>
                                      <Grid>
                                        <Box
                                          sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "8px",
                                            // marginTop: 1
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              display: "flex",
                                              gap: "8px",
                                              flexDirection: "column",
                                              width: "170px",
                                            }}
                                          >
                                            <MuiDatePicker
                                              label="DOB"
                                              value={dob}
                                              onChange={(e) => {
                                                setDob(e)
                                                if (editdetails) {
                                                  setAge(CalculateAge(e));
                                                }
                                              }}
                                              onKeyDown={handleDatePickerEnterNav}
                                              disabled={true}
                                              disableFuture
                                              // minDate={new Date('2000-01-01')}
                                              format="DD-MM-YYYY"
                                              sx={{ backgroundColor: "white" }}
                                            />
                                            {doberror !== "" &&
                                              (!dob || dob.$d == "Invalid Date") && (
                                                <Typography
                                                  sx={{
                                                    alignSelf: "stretch",
                                                    fontFamily: "inter",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    fontWeight: "400",
                                                    lineHeight: "8px",
                                                    color: "red",
                                                  }}
                                                >
                                                  {doberror}
                                                </Typography>
                                              )}
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              gap: "8px",
                                              flexDirection: "column",
                                              width: "170px",
                                            }}
                                          >
                                            <MuiDatePicker
                                              label="DOJ"
                                              value={doj}
                                              onChange={(e) => setDoj(e)}
                                              onKeyDown={handleDatePickerEnterNav}
                                              disabled={
                                                searchMemberStatus && !editdetails
                                              }
                                              disableFuture
                                              // minDate={new Date('2000-01-01')}
                                              format="DD-MM-YYYY"
                                              sx={{ backgroundColor: "white" }}
                                            />
                                            {dojerror !== "" &&
                                              (!doj || doj.$d == "Invalid Date") && (
                                                <Typography
                                                  sx={{
                                                    alignSelf: "stretch",
                                                    fontFamily: "inter",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    fontWeight: "400",
                                                    lineHeight: "8px",
                                                    color: "red",
                                                  }}
                                                >
                                                  {dojerror}
                                                </Typography>
                                              )}
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              gap: "8px",
                                              flexDirection: "column",
                                              width: "170px",
                                            }}
                                          >
                                            <MuiDatePicker
                                              label="Terminated Date"
                                              value={terminateddate}
                                              onChange={(e) => setTerminateddate(e)}
                                              onKeyDown={handleDatePickerEnterNav}
                                              disabled={
                                                searchMemberStatus && !editdetails
                                              }
                                              disableFuture
                                              // minDate={new Date('2000-01-01')}
                                              format="DD-MM-YYYY"
                                              sx={{ backgroundColor: "white" }}
                                            />
                                            {terminatederror !== "" &&
                                              terminateddate &&
                                              terminateddate.$d == "Invalid Date" && (
                                                <Typography
                                                  sx={{
                                                    alignSelf: "stretch",
                                                    fontFamily: "inter",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    fontWeight: "400",
                                                    lineHeight: "8px",
                                                    color: "red",
                                                  }}
                                                >
                                                  {terminatederror}
                                                </Typography>
                                              )}
                                          </Box>

                                          <Box
                                            sx={{
                                              display: "flex",
                                              gap: "8px",
                                              flexDirection: "column",
                                              width: "170px",
                                            }}
                                          >
                                            <MuiDatePicker
                                              label="Deceased Date"
                                              value={deceaseddate}
                                              onChange={(e) => setDeceaseddate(e)}
                                              onKeyDown={handleDatePickerEnterNav}
                                              disabled={
                                                searchMemberStatus && !editdetails
                                              }
                                              disableFuture
                                              // minDate={new Date('2000-01-01')}
                                              format="DD-MM-YYYY"
                                              sx={{ backgroundColor: "white" }}
                                            />
                                            {deceasederror !== "" &&
                                              deceaseddate &&
                                              deceaseddate.$d == "Invalid Date" && (
                                                <Typography
                                                  sx={{
                                                    alignSelf: "stretch",
                                                    fontFamily: "inter",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    fontWeight: "400",
                                                    lineHeight: "8px",
                                                    color: "red",
                                                  }}
                                                >
                                                  {deceasederror}
                                                </Typography>
                                              )}
                                          </Box>
                                          {/* <FormControlLabel
                                            control={<Checkbox color="success" />}
                                            label="No Mailer"
                                            disabled={searchMemberStatus && !editdetails}
                                            checked={nomailer}
                                            onChange={(e) => setNomailer(!nomailer)}
                                            onKeyDown={handleCustomEnterNav}
                                            sx={{ paddingLeft: '5px',
                                            }}
                                          /> */}
                                        </Box>
                                      </Grid>
                                      <Grid>
                                        <Box
                                          sx={{
                                            display: "flex",
                                            gap: "8px",
                                            flexDirection: "column",
                                            // marginTop: '8px'
                                          }}
                                        >
                                          <MuiAutocomplete
                                            id="select-sex"
                                            disabled={
                                              searchMemberStatus && !editdetails
                                            }
                                            value={sex}
                                            onChange={(event, newValue) => {
                                              setSex(newValue);
                                            }}
                                            onKeyDown={handleCustomEnterNav}
                                            options={sexArray.map(
                                              (option) => option.code
                                            )}
                                            getOptionLabel={(option) =>
                                              sexArray.find(
                                                (sexOption) => sexOption.code === option
                                              )?.name || ""
                                            }
                                            label="Gender"
                                            autoCompleteStyle={{ width: "350px" }}
                                          />
                                          <MuiAutocomplete
                                            id="select-race"
                                            disabled={
                                              searchMemberStatus && !editdetails
                                            }
                                            value={race}
                                            onChange={(event, newValue) => {
                                              setRace(newValue);
                                            }}
                                            onKeyDown={handleCustomEnterNav}
                                            options={raceArray.map(
                                              (option) => option.code
                                            )}
                                            getOptionLabel={(option) =>
                                              raceArray.find(
                                                (raceOption) =>
                                                  raceOption.code === option
                                              )?.name || ""
                                            }
                                            label="Race"
                                            autoCompleteStyle={{ width: "350px" }}
                                            textFieldStyle={{
                                              color:
                                                searchMemberStatus && !editdetails
                                                  ? "#242424"
                                                  : "#101010",
                                            }}
                                          />

                                          <MuiAutocomplete
                                            id="select-education"
                                            disabled={true}
                                            label="Education"
                                            onKeyDown={handleCustomEnterNav}
                                            autoCompleteStyle={{ width: "350px" }}
                                            textFieldStyle={{
                                              color:
                                                searchMemberStatus && !editdetails
                                                  ? "#242424"
                                                  : "#101010",
                                            }}
                                          />
                                          <MuiAutocomplete
                                            id="select-occupation"
                                            label="Occupation"
                                            disabled={searchMemberStatus && !editdetails}
                                            value={occupation || null}
                                            onChange={(event, newValue) => {
                                              setOccupation(newValue);
                                            }}
                                            onKeyDown={handleCustomEnterNav}
                                            options={occupationArray.map(
                                              (option) => option.name
                                            )}
                                            getOptionLabel={(option) =>
                                              occupationArray.find(
                                                (occupationOption) =>
                                                  occupationOption.name === option
                                              )?.name || ""
                                            }
                                            autoCompleteStyle={{ width: "350px" }}
                                            textFieldStyle={{
                                              color:
                                                searchMemberStatus && !editdetails
                                                  ? "#242424"
                                                  : "#101010",
                                            }}
                                          />
                                          {/* <FormControlLabel
                                            control={<Checkbox color="success" />}
                                            label="Non-Benefit Member"
                                            disabled={searchMemberStatus && !editdetails}
                                            checked={nonbenifit}
                                            onKeyDown={handleCustomEnterNav}
                                            onChange={(e) => setNonBenefit(!nonbenifit)}
                                            sx={{ paddingLeft: '5px' }}
                                          /> */}

                                        </Box>
                                      </Grid>

                                      <Grid>
                                        <Box
                                          sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            paddingLeft: '10px',
                                            // marginTop: '10px',
                                          }}
                                        >
                                          <Box sx={{ display: "flex" }}>
                                            <FormControlLabel
                                              control={<Checkbox color="success" />}
                                              label="Delegate"
                                              disabled={searchMemberStatus && !editdetails}
                                              checked={delegate}
                                              onChange={(e) => { setDelegate(!delegate); setDelegateSinceError('') }}
                                              onKeyDown={handleCustomEnterNav}
                                            />
                                            <Box sx={{ display: "flex", flexDirection: 'column' }}>
                                              {delegate && (
                                                <MuiDatePicker
                                                  label="Since Year"
                                                  name="delegatesince"
                                                  value={delegatesince}
                                                  onChange={(newValue) => setDelegateSince(newValue)}
                                                  onKeyDown={handleDatePickerEnterNav}
                                                  format="YYYY"
                                                  views={['year']}
                                                  sx={{ width: '120px', height: '36px' }}
                                                  disabled={
                                                    searchMemberStatus && !editdetails
                                                  }
                                                />
                                              )}
                                              {delegate && delegateSinceError !== '' && !delegatesince && (
                                                <Typography
                                                  sx={{
                                                    alignSelf: 'stretch',
                                                    fontFamily: 'inter',
                                                    fontSize: '16px',
                                                    fontStyle: 'normal',
                                                    fontWeight: '400',
                                                    lineHeight: '8px',
                                                    color: 'red',
                                                    marginTop: '8px'
                                                  }}
                                                >
                                                  {delegateSinceError}
                                                </Typography>
                                              )}
                                            </Box>
                                          </Box>
                                          <FormControlLabel
                                            control={<Checkbox color="success" />}
                                            label="Director"
                                            disabled={searchMemberStatus && !editdetails}
                                            checked={director}
                                            onChange={(e) => setDirector(!director)}
                                            onKeyDown={handleCustomEnterNav}
                                          />
                                          <FormControlLabel
                                            control={<Checkbox color="success" />}
                                            label="Observer"
                                            disabled={searchMemberStatus && !editdetails}
                                            checked={observer}
                                            onChange={(e) => setObserver(!observer)}
                                            onKeyDown={handleCustomEnterNav}
                                          />
                                          <FormControlLabel
                                            control={<Checkbox color="success" />}
                                            label="Other - Disciplinary Action"
                                            disabled={searchMemberStatus && !editdetails}
                                            checked={dispaction}
                                            onChange={(e) => setDispAction(!dispaction)}
                                            onKeyDown={handleCustomEnterNav}
                                          />
                                          <FormControlLabel
                                            control={<Checkbox color="success" />}
                                            label="Company"
                                            disabled={searchMemberStatus && !editdetails}
                                            checked={company}
                                            onChange={(e) => setCompany(!company)}
                                            onKeyDown={handleCustomEnterNav}
                                          />

                                        </Box>
                                      </Grid>
                                    </Box>
                                  </Box>
                                </Box>
                                <Box sx={{ display: 'flex', gap: '85px' }}>
                                  <Box>
                                    <Typography
                                      sx={{
                                        fontFamily: "inter",
                                        fontWeight: "500",
                                        fontSize: "18px",
                                        lineHeight: "28px",
                                        color: "#64748B",
                                      }}
                                    >
                                      Bank Account Information
                                    </Typography>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        gap: "20px",
                                        flexDirection: "row",
                                      }}
                                    >
                                      <Box sx={{ display: "flex", gap: "8px" }}>
                                        <Box
                                          sx={{
                                            display: "flex",
                                            gap: "8px",
                                            flexDirection: "column",
                                            maxWidth: "280px",
                                            width: "100%",
                                          }}
                                        >
                                          {/* <Typography sx={{ alignSelf: "stretch", width: "200px", fontFamily: "inter", fontSize: "16px", fontStyle: "inter", fontWeight: "400", lineHeight: "8px",color:"#101010"}}>Bank</Typography> */}
                                          {/* <Dropdown
                                showClear
                                disabled={searchMemberStatus && !editdetails}
                                value={bank}
                                onChange={(e) => setBank(e.target.value)}
                                style={{
                                  padding: "8px 12px",
                                  width: "280px",
                                  borderRadius: "4px",
                                  border:
                                    "1px solid var(--Light-Forms-Border, #CBD5E1)",
                                  fontSize: "8px",
                                  height: "35px",
                                  fontWeight: "400",
                                  lineHeight: "20px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                                options={bankList.sort()}
                                filter
                                placeholder="Select bank"
                              /> */}

                                          <MuiAutocomplete
                                            labelId="select-bank-label"
                                            id="select-bank"
                                            disabled={searchMemberStatus && !editdetails}
                                            value={bank}
                                            onChange={(event, newValue) =>
                                              setBank(newValue)
                                            }
                                            onKeyDown={handleAutocompleteEnterNav}
                                            options={bankList.sort()}
                                            label="Select Bank"
                                            autoCompleteStyle={{
                                              width: "280px",
                                              backgroundColor: "#FFF",
                                              fontSize: "8px",
                                              fontWeight: "400",
                                              "& .MuiInputBase-input": {
                                                color: "#000",
                                                marginLeft: "10px",
                                              },
                                              color:
                                                searchMemberStatus && !editdetails
                                                  ? "#242424"
                                                  : "#101010",
                                            }}
                                          />
                                          {/* <Autocomplete
                                disablePortal
                                labelId="select-bank-label"
                                id="select-bank"
                                disabled={searchMemberStatus && !editdetails}
                                value={bank}
                                onChange={(e, newValue) => setBank(newValue)}
                                options={bankList.sort()}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Select bank"
                                    sx={{
                                      width: "280px",
                                      backgroundColor: "#FFF",
                                      fontSize: "8px",
                                      fontWeight: "400",
                                      "& .MuiInputBase-input": {
                                        color: "#000",
                                        marginLeft: "10px",
                                      },
                                      color:
                                        searchMemberStatus && !editdetails
                                          ? "#242424"
                                          : "#101010",
                                    }}
                                    InputLabelProps={{
                                      style: {
                                        color: "#000",
                                      },
                                    }}
                                  />
                                )}
                              /> */}
                                        </Box>
                                        <Box
                                          sx={{
                                            display: "flex",
                                            gap: "8px",
                                            flexDirection: "column",
                                            maxWidth: "280px",
                                            width: "100%",
                                          }}
                                        >
                                          {/* <Typography sx={{ alignSelf: "stretch", width: "200px", fontFamily: "inter", fontSize: "16px", fontStyle: "inter", fontWeight: "400", lineHeight: "8px",color:"#101010" }}>A/C Number</Typography> */}
                                          <MuiInput
                                            label="A/C Number"
                                            variant="outlined"
                                            disabled={
                                              (searchMemberStatus && !editdetails) ||
                                              (searchMemberStatus &&
                                                !editdetails &&
                                                getBankLength(bank) == null) ||
                                              getBankLength(bank) == null
                                            }
                                            value={accNo}
                                            onChange={handleAccountNumberChange}
                                            onKeyDown={handleCustomEnterNav}
                                            mask={getMaskForLength(getBankLength(bank))}
                                            // InputProps={{
                                            //   maxLength:
                                            //     getBankLength(bank) +
                                            //     (Math.ceil(getBankLength(bank) / 4) - 1),
                                            // }}
                                            style={{
                                              width: "100%",
                                              backgroundColor: "#FFF",
                                              fontSize: "14px",
                                              color:
                                                searchMemberStatus && !editdetails
                                                  ? "#242424"
                                                  : "#101010",
                                            }}
                                          />
                                        </Box>
                                      </Box>
                                    </Box>
                                  </Box>
                                </Box>
                                <Box sx={{
                                  display: "flex",
                                  width: "100%",
                                  gap: "690px",
                                }}>
                                  
                                </Box>
                                <Box sx={{ display: 'flex', width: '100%' ,gap:'20px',alignSelf:'flex-start'}}>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      gap: "4px",
                                      flexDirection: "column",
                                      width: '77.1%',
                                    }}
                                  >
                                    <Typography
                                    sx={{
                                      fontFamily: "inter",
                                      fontWeight: "500",
                                      fontSize: "18px",
                                      // lineHeight: "28px",
                                      color: "#64748B",
                                    }}
                                  >
                                    Modes of Communication
                                  </Typography>
                                  
                                    <Box sx={{ display: 'flex', direction: 'row', gap: '8px' }}>
                                      <MuiInput
                                          label="Email ID"
                                          variant="outlined"
                                          disabled={searchMemberStatus && !editdetails}
                                          value={memberEmail}
                                          onChange={(e) => setMemberEmail(e.target.value)}
                                          onKeyDown={handleCustomEnterNav}
                                          sx={{
                                            width: "60%",
                                            backgroundColor: "#FFF",
                                            fontSize: "14px",
                                            color: "#101010",
                                          }}
                                        />
                                         <MuiInput
                                          label="Password"
                                          variant="outlined"
                                          disabled={true}
                                          required
                                          value={password}
                                          onChange={(e) => setPassword(e.target.value)}
                                          onKeyDown={handleCustomEnterNav}
                                          sx={{
                                            width: "22.5%",
                                            backgroundColor: "#FFF",
                                            fontSize: "14px",
                                            color: "#101010",
                                          }}
                                        /> 
                                         {passworderror !== "" && password?.trim() == "" && (
                                          <Typography
                                            sx={{
                                              alignSelf: "stretch",
                                              fontFamily: "inter",
                                              fontSize: "16px",
                                              fontStyle: "normal",
                                              fontWeight: "400",
                                              lineHeight: "24px",
                                              color: "red",
                                            }}
                                          >
                                            {passworderror}
                                          </Typography>
                                        )} 
                                    </Box>
                                    <Box sx={{ display: 'flex', direction: 'row', gap: '8px' }}>
                                      
                                      <MuiInput
                                        label="HP (Whatsapp)"
                                        variant="outlined"
                                        disabled={searchMemberStatus && !editdetails}
                                        value={hpWpNo}
                                        onChange={handleHpWpChange}
                                        onKeyDown={handleCustomEnterNav}
                                        sx={{
                                          maxWidth: "160px",
                                          backgroundColor: "#FFF",
                                          fontSize: "14px",
                                          color:
                                            searchMemberStatus && !editdetails
                                              ? "#242424"
                                              : "#101010",
                                        }}
                                      />
                                      <MuiInput
                                        label="Name"
                                        variant="outlined"
                                        disabled={true}
                                        onKeyDown={handleCustomEnterNav}
                                        sx={{
                                          minWidth: "600px",
                                          maxWidth: "650px",
                                          backgroundColor: "#FFF",
                                          fontSize: "14px",
                                          color:
                                            searchMemberStatus && !editdetails
                                              ? "#242424"
                                              : "#101010",
                                        }}
                                      />
                                      <MuiAutocomplete
                                        id="select-relationship"
                                        disabled={true}
                                        // value={race}
                                        // onChange={(event, newValue) => {
                                        //   setRace(newValue);
                                        // }}
                                        options={relationshipArray.map(
                                          (option) => option.code
                                        )}
                                        onKeyDown={handleCustomEnterNav}
                                        getOptionLabel={(option) =>
                                          relationshipArray.find(
                                            (relationshipOption) =>
                                              relationshipOption.code === option
                                          )?.name || ""
                                        }
                                        label="Relationship"
                                        autoCompleteStyle={{ maxWidth: "160px" }}
                                        textFieldStyle={{
                                          color:
                                            searchMemberStatus && !editdetails
                                              ? "#242424"
                                              : "#101010",
                                        }}
                                      />
                                    </Box>
                                    <Box sx={{ display: 'flex', direction: 'row', gap: '8px' }}>
                                      <MuiInput
                                        label="HP"
                                        variant="outlined"
                                        disabled={searchMemberStatus && !editdetails}
                                        value={hpNo}
                                        onChange={handleHpChange}
                                        onKeyDown={handleCustomEnterNav}
                                        sx={{
                                          maxWidth: "160px",
                                          backgroundColor: "#FFF",
                                          fontSize: "14px",
                                          color:
                                            searchMemberStatus && !editdetails
                                              ? "#242424"
                                              : "#101010",
                                        }}
                                      />
                                      <MuiInput
                                        label="Name"
                                        variant="outlined"
                                        disabled={true}
                                        onKeyDown={handleCustomEnterNav}
                                        sx={{
                                          minWidth: "600px",
                                          maxWidth: "650px",
                                          backgroundColor: "#FFF",
                                          fontSize: "14px",
                                          color:
                                            searchMemberStatus && !editdetails
                                              ? "#242424"
                                              : "#101010",
                                        }}
                                      />
                                      <MuiAutocomplete
                                        id="select-relationship"
                                        disabled={true}
                                        onKeyDown={handleCustomEnterNav}
                                        // value={race}
                                        // onChange={(event, newValue) => {
                                        //   setRace(newValue);
                                        // }}
                                        options={relationshipArray.map(
                                          (option) => option.code
                                        )}
                                        getOptionLabel={(option) =>
                                          relationshipArray.find(
                                            (relationshipOption) =>
                                              relationshipOption.code === option
                                          )?.name || ""
                                        }
                                        label="Relationship"
                                        autoCompleteStyle={{ maxWidth: "160px", }}
                                        textFieldStyle={{
                                          color:
                                            searchMemberStatus && !editdetails
                                              ? "#242424"
                                              : "#101010",
                                        }}
                                      />
                                    </Box>
                                    <Box sx={{ display: 'flex', direction: 'row', gap: '8px' }}>
                                      <MuiInput
                                        label="Telephone (Office)"
                                        variant="outlined"
                                        disabled={searchMemberStatus && !editdetails}
                                        value={officeTel}
                                        onChange={handleOfficeTelChange}
                                        onKeyDown={handleCustomEnterNav}
                                        sx={{
                                          maxWidth: "160px",
                                          backgroundColor: "#FFF",
                                          fontSize: "14px",
                                          color:
                                            searchMemberStatus && !editdetails
                                              ? "#242424"
                                              : "#101010",
                                        }}
                                      />
                                      <MuiInput
                                        label="Name"
                                        variant="outlined"
                                        disabled={true}
                                        onKeyDown={handleCustomEnterNav}
                                        sx={{
                                          minWidth: "600px",
                                          maxWidth: "650px",
                                          backgroundColor: "#FFF",
                                          fontSize: "14px",
                                          color:
                                            searchMemberStatus && !editdetails
                                              ? "#242424"
                                              : "#101010",
                                        }}
                                      />
                                      <MuiAutocomplete
                                        id="select-relationship"
                                        disabled={true}
                                        // value={race}
                                        // onChange={(event, newValue) => {
                                        //   setRace(newValue);
                                        // }}
                                        options={relationshipArray.map(
                                          (option) => option.code
                                        )}
                                        onKeyDown={handleCustomEnterNav}
                                        getOptionLabel={(option) =>
                                          relationshipArray.find(
                                            (relationshipOption) =>
                                              relationshipOption.code === option
                                          )?.name || ""
                                        }
                                        label="Relationship"
                                        autoCompleteStyle={{ maxWidth: "160px", }}
                                        textFieldStyle={{
                                          color:
                                            searchMemberStatus && !editdetails
                                              ? "#242424"
                                              : "#101010",
                                        }}
                                      />
                                    </Box>
                                    <Box sx={{ display: 'flex', direction: 'row', gap: '8px' }}>
                                      <MuiInput
                                        label="Telephone (Home)"
                                        variant="outlined"
                                        disabled={searchMemberStatus && !editdetails}
                                        value={houseTel}
                                        onChange={handleHouseTelChange}
                                        onKeyDown={handleCustomEnterNav}
                                        sx={{
                                          maxWidth: "160px",
                                          backgroundColor: "#FFF",
                                          fontSize: "14px",
                                          color:
                                            searchMemberStatus && !editdetails
                                              ? "#242424"
                                              : "#101010",
                                        }}
                                      />
                                      <MuiInput
                                        label="Name"
                                        variant="outlined"
                                        disabled={true}
                                        onKeyDown={handleCustomEnterNav}
                                        sx={{
                                          minWidth: "600px",
                                          maxWidth: "650px",
                                          backgroundColor: "#FFF",
                                          fontSize: "14px",
                                          color:
                                            searchMemberStatus && !editdetails
                                              ? "#242424"
                                              : "#101010",
                                        }}
                                      />
                                      <MuiAutocomplete
                                        id="select-relationship"
                                        disabled={true}
                                        // value={race}
                                        // onChange={(event, newValue) => {
                                        //   setRace(newValue);
                                        // }}
                                        options={relationshipArray.map(
                                          (option) => option.code
                                        )}
                                        onKeyDown={handleCustomEnterNav}
                                        getOptionLabel={(option) =>
                                          relationshipArray.find(
                                            (relationshipOption) =>
                                              relationshipOption.code === option
                                          )?.name || ""
                                        }
                                        label="Relationship"
                                        autoCompleteStyle={{ maxWidth: "160px", }}
                                        textFieldStyle={{
                                          color:
                                            searchMemberStatus && !editdetails
                                              ? "#242424"
                                              : "#101010",
                                        }}
                                      />
                                    </Box>
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <Typography
                                    sx={{
                                      fontFamily: "inter",
                                      fontWeight: "500",
                                      fontSize: "18px",
                                      lineHeight: "28px",
                                      color: "#64748B",
                                    }}
                                  >
                                    Certification Details
                                  </Typography>
                                  
                                    <FormControlLabel
                                      control={<Checkbox color="success" />}
                                      label="Photocopy of MyKAD in File."
                                      disabled={searchMemberStatus && !editdetails}
                                      checked={mykad}
                                      onChange={(e) => setMykad(!mykad)}
                                      onKeyDown={handleCustomEnterNav}
                                    />
                                    <FormControlLabel
                                      control={<Checkbox color="success" />}
                                      label="Member Nomination Form in File."
                                      disabled={searchMemberStatus && !editdetails}
                                      checked={nomform}
                                      onChange={(e) => setNomForm(!nomform)}
                                      onKeyDown={handleCustomEnterNav}
                                    />
                                    <FormControlLabel
                                      control={<Checkbox color="success" />}
                                      label="Nominee MyKad New."
                                      disabled={searchMemberStatus && !editdetails}
                                      checked={nommykad}
                                      onChange={(e) => setNomMykad(!nommykad)}
                                      onKeyDown={handleCustomEnterNav}
                                    />
                                    <FormControlLabel
                                      control={<Checkbox color="success" />}
                                      label="Death Certificate in File."
                                      disabled={searchMemberStatus && !editdetails}
                                      checked={deathcert}
                                      onChange={(e) => setDeathCert(!deathcert)}
                                      onKeyDown={handleCustomEnterNav}
                                    />
                                  </Box>
                                  <Box>
                                      <Box style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                        <Typography
                                          htmlFor="notes-textarea"
                                          component="label"
                                          sx={{
                                            fontFamily: 'inter',
                                            fontWeight: '500',
                                            fontSize: '18px',
                                            lineHeight: '28px',
                                            color: '#64748B',
                                            
                                          }}
                                        >
                                          Notes
                                        </Typography>
                                        <TextareaAutosize
                                          id="notes-textarea"
                                          minRows={10}
                                          maxRows={12}
                                          disabled={searchMemberStatus && !editdetails}
                                          value={notes}
                                          onChange={(e) => setNotes(e.target.value)}
                                          onKeyDown={handleCustomEnterNav}
                                          placeholder="Add your notes here..."
                                          style={{
                                            width: '100%',
                                            backgroundColor: '#FFF',
                                            fontSize: '14px',
                                            color: searchMemberStatus && !editdetails ? '#242424' : '#101010',
                                            padding: '8px',
                                            borderRadius: '4px',
                                            borderColor: '#c4c4c4',
                                            borderWidth: '1px',
                                            borderStyle: 'solid',
                                            resize: 'vertical',
                                          }}
                                        />
                                      </Box>
                                    </Box>
                                  </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    gap: "5px",
                                    paddingTop: "10px",
                                    // paddingLeft: "4px",
                                  }}
                                >
                                  <Box style={{ display: 'flex', gap: '5px' }}>
                                    <Box>
                                      <MuiAutocomplete
                                        labelId="select-estate-label"
                                        id="select-estate"
                                        disabled={
                                          searchMemberStatus && !editdetails
                                        }
                                        value={estate}
                                        onChange={(event, newValue) =>
                                          setEstate(newValue)
                                        }
                                        onKeyDown={handleCustomEnterNav}
                                        options={estatesArray.sort()}
                                        label="Select Estate"
                                        autoCompleteStyle={{
                                          '& .MuiInputBase-root': {
                                            height: '35px !important',
                                            width: "500px !important",
                                          },
                                        }}
                                        textFieldStyle={{
                                          width: "500px",
                                          color:
                                            searchMemberStatus && !editdetails
                                              ? "#242424"
                                              : "#101010",
                                        }}
                                        multiline={true}
                                        maxRows={3}
                                      />
                                      {estateError !== '' && !estate && (
                                        <Typography
                                          sx={{
                                            alignSelf: "stretch",
                                            fontFamily: "inter",
                                            fontSize: "16px",
                                            fontStyle: "normal",
                                            fontWeight: "400",
                                            lineHeight: "24px",
                                            color: "red",
                                          }}
                                        >
                                          {estateError}
                                        </Typography>
                                      )}
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                      <MuiInput
                                        label="State"
                                        variant="outlined"
                                        disabled={
                                          searchMemberStatus && !editdetails
                                        }
                                        value={state}
                                        sx={{
                                          width: "100%",
                                          minWidth:"262px",
                                          backgroundColor: "#FFF",
                                          fontSize: "14px",
                                          color:
                                            searchMemberStatus && !editdetails
                                              ? "#242424"
                                              : "#101010",
                                        }}
                                        onKeyDown={handleCustomEnterNav}
                                      />

                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                      <MuiInput
                                        label="Region"
                                        variant="outlined"
                                        disabled={true}
                                        // value={}
                                        sx={{
                                          width: "100%",
                                          maxWidth:"165px",
                                          backgroundColor: "#FFF",
                                          fontSize: "14px",
                                          color:
                                            searchMemberStatus && !editdetails
                                              ? "#242424"
                                              : "#101010",
                                        }}
                                        onKeyDown={handleCustomEnterNav}
                                      />
                                      {/* <MuiInput
                                        label="State"
                                        variant="outlined"
                                        disabled={
                                          searchMemberStatus && !editdetails
                                        }
                                        value={state}
                                        sx={{
                                          width: "100%",
                                          backgroundColor: "#FFF",
                                          fontSize: "14px",
                                          color:
                                            searchMemberStatus && !editdetails
                                              ? "#242424"
                                              : "#101010",
                                        }}
                                        onKeyDown={handleCustomEnterNav}
                                      /> */}

                                    </Box>
                                  </Box>
                                  {/* <Box>
                                    <MuiInput
                                      label="Notes"
                                      // placeholder="Add your notes here..."
                                      variant="outlined"
                                      disabled={searchMemberStatus && !editdetails}
                                      value={notes}
                                      onChange={(e) => setNotes(e.target.value)}
                                      sx={{
                                        backgroundColor: "#FFF",
                                        width: "500px",
                                        fontSize: "14px",
                                        color:
                                          searchMemberStatus && !editdetails
                                            ? "#242424"
                                            : "#101010",
                                      }}
                                      onKeyDown={handleCustomEnterNav}
                                    />
                                  </Box> */}
                                </Box>
                                <Accordion
                                  expanded={expanded}
                                  onChange={handleExpansion}
                                  slots={{ transition: Fade }}
                                  slotProps={{ transition: { timeout: 400 } }}
                                  sx={{
                                    '& .MuiAccordion-region': { height: expanded ? 'auto' : 0 },
                                    '& .MuiAccordionDetails-root': { display: expanded ? 'block' : 'none' },
                                    pointerEvents: memberNo == "" && "none",
                                    opacity: memberNo == "" && "0.5",
                                    marginTop: '10px'
                                  }}
                                >
                                  <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                  >
                                    <Typography
                                      sx={{
                                        fontFamily: "inter",
                                        fontWeight: "500",
                                        fontSize: "18px",
                                        lineHeight: "28px",
                                        color: "#64748B",
                                      }}
                                    >
                                      Correspondence Address{" "}
                                      <span style={{ fontSize: "14px" }}>
                                        (Only if different from the address above)
                                      </span>
                                    </Typography>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    <MuiInput
                                      label="Address 1"
                                      variant="outlined"
                                      disabled={
                                        (searchMemberStatus && !editdetails) ||
                                          memberNo == ""
                                          ? true
                                          : false
                                      }
                                      value={corradress1}
                                      onChange={(e) => setCorrAdress1(e.target.value)}
                                      onKeyDown={handleCustomEnterNav}
                                      sx={{
                                        backgroundColor: "#FFF",
                                        width: "100%",
                                        fontSize: "14px",
                                        color:
                                          searchMemberStatus && !editdetails
                                            ? "#242424"
                                            : "#101010",
                                      }}
                                    />
                                    <MuiInput
                                      label="Address 2"
                                      variant="outlined"
                                      disabled={
                                        (searchMemberStatus && !editdetails) ||
                                          memberNo == ""
                                          ? true
                                          : false
                                      }
                                      value={corradress2}
                                      onChange={(e) => setCorrAdress2(e.target.value)}
                                      onKeyDown={handleCustomEnterNav}
                                      sx={{
                                        marginTop: "12px",
                                        backgroundColor: "#FFF",
                                        width: "100%",
                                        fontSize: "14px",
                                        color:
                                          searchMemberStatus && !editdetails
                                            ? "#242424"
                                            : "#101010",
                                      }}
                                    />
                                    <MuiInput
                                      label="Address 3"
                                      variant="outlined"
                                      disabled={
                                        (searchMemberStatus && !editdetails) ||
                                          memberNo == ""
                                          ? true
                                          : false
                                      }
                                      value={corradress3}
                                      onChange={(e) => setCorrAdress3(e.target.value)}
                                      onKeyDown={handleCustomEnterNav}
                                      sx={{
                                        marginTop: "12px",
                                        backgroundColor: "#FFF",
                                        width: "100%",
                                        fontSize: "14px",
                                        color:
                                          searchMemberStatus && !editdetails
                                            ? "#242424"
                                            : "#101010",
                                      }}
                                    />
                                    <MuiInput
                                      label="Address 4"
                                      variant="outlined"
                                      disabled={
                                        (searchMemberStatus && !editdetails) ||
                                          memberNo == ""
                                          ? true
                                          : false
                                      }
                                      value={corradress4}
                                      onChange={(e) => setCorrAdress4(e.target.value)}
                                      onKeyDown={handleCustomEnterNav}
                                      sx={{
                                        marginTop: "12px",
                                        backgroundColor: "#FFF",
                                        width: "100%",
                                        fontSize: "14px",
                                        color:
                                          searchMemberStatus && !editdetails
                                            ? "#242424"
                                            : "#101010",
                                      }}
                                    />
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        marginTop: "12px",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        {corressAddressError !== "" && (
                                          <Typography
                                            sx={{
                                              alignSelf: "stretch",
                                              width: "390px",
                                              fontFamily: "inter",
                                              fontSize: "13px",
                                              fontStyle: "inter",
                                              fontWeight: "400",
                                              lineHeight: "24px",
                                              color: "red",
                                            }}
                                          >
                                            {corressAddressError}
                                          </Typography>
                                        )}
                                      </Box>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "row",
                                          gap: "24px",
                                        }}
                                      >
                                        {memberNo != "" && editdetails == true && (
                                          <Button
                                            disabled={
                                              memberNo == "" ||
                                              (searchMemberStatus && !editdetails)
                                            }
                                            fullWidth
                                            variant="contained"
                                            sx={{
                                              width: "120px",
                                              height: "32px",
                                              borderRadius: "4px",
                                              display: "flex",
                                              gap: "6px",
                                              justifyContent: "flex-start",
                                            }}
                                            color="error"
                                            onClick={(e) =>
                                              handleCorrespondanceSave(e, "delete")
                                            }
                                          >
                                            <Typography
                                              sx={{
                                                width: "100%",
                                                fontFamily: "inter",
                                                fontSize: "16px",
                                                fontWeight: "400",
                                                lineHeight: "24px",
                                                textTransform: "none",
                                                textAlign: "center",
                                              }}
                                            >
                                              Delete
                                            </Typography>
                                          </Button>
                                        )}
                                        <Button
                                          disabled={
                                            memberNo == "" ||
                                            (searchMemberStatus && !editdetails)
                                          }
                                          fullWidth
                                          variant="contained"
                                          sx={{
                                            width: "120px",
                                            height: "32px",
                                            borderRadius: "4px",
                                            display: "flex",
                                            gap: "6px",
                                            justifyContent: "flex-start",
                                            background: "#E7EFE9",
                                          }}
                                          onClick={(e) =>
                                            handleCorrespondanceSave(e, "update")
                                          }
                                        >
                                          <Typography
                                            sx={{
                                              width: "100%",
                                              fontFamily: "inter",
                                              fontSize: "16px",
                                              fontWeight: "400",
                                              lineHeight: "24px",
                                              textTransform: "none",
                                              textAlign: "center",
                                            }}
                                          >
                                            Add
                                          </Typography>
                                        </Button>
                                      </Box>
                                    </Box>
                                  </AccordionDetails>
                                </Accordion>
                              </Grid>
                              <Grid item xs={1.6}>
                                <Box sx={{ padding: "0px 16px" }}>
                                  {imageStatus == true ? (
                                    <Box
                                      component="img"
                                      src={selectedImage}
                                      sx={{
                                        width: "200px",
                                        height: "200px",
                                        objectFit: "contain",
                                        // background: "#CBD5E1",
                                        border: "none",
                                      }}
                                      onError={(e) => {
                                        setImageStatus(false);
                                      }}
                                    ></Box>
                                  ) : (
                                    <Box
                                      sx={{
                                        width: "172px",
                                        height: "172px",
                                        background: "#CBD5E1",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <AccountCircleTwoToneIcon
                                        sx={{
                                          width: "103px",
                                          height: "103px",
                                          objectFit: "cover",
                                          border: "none",
                                          color: "#94A3B8",
                                        }}
                                      />
                                    </Box>
                                  )}

                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "8px",
                                      marginTop: "10px",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                      }}
                                    >
                                      <InsertPhotoIcon color="primary" />
                                      <Typography
                                        sx={{
                                          fontSize: "16px",
                                          fontWeight: 400,
                                          lineHeight: "24px",
                                          color: "#288d2c",
                                          cursor: searchMemberStatus && !editdetails ? "not-allowed" : "pointer",
                                        }}
                                        onClick={
                                          searchMemberStatus
                                            ? editdetails
                                              ? loadFile
                                              : () => { }
                                            : loadFile
                                        }
                                      >
                                        Add photo
                                        <input
                                          id="image-upload"
                                          type="file"
                                          accept="image/*" // Allow only image files
                                          style={{
                                            padding: "10px 20px",
                                            marginTop: "8px",
                                            marginBottom: "18px",
                                            color: "white",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                            display: "none",
                                            color: "var(--pallate-green-500, #E7EFE9)",
                                          }}
                                          onChange={handleImageUpload}
                                        />
                                      </Typography>
                                    </Box>
                                    {imageStatus &&
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                        }}
                                      >
                                        <DeleteIcon color="error" /> {/* Set icon color to red using the 'error' color */}
                                        <Typography
                                          sx={{
                                            fontSize: "16px",
                                            fontWeight: 400,
                                            lineHeight: "24px",
                                            color: "red", // Set text color to red
                                            cursor: searchMemberStatus && !editdetails ? "not-allowed" : "pointer",
                                          }}
                                          onClick={
                                            searchMemberStatus && !editdetails
                                              ? null
                                              : () => setImageStatus(false) // Assume setImageStatus is to toggle the image display state
                                          }
                                        >
                                          Remove photo
                                        </Typography>
                                      </Box>}
                                  </Box>
                                </Box>
                              </Grid>
                            </Grid>
                          </form>
                        </Box>
                      )}
                      {active == "Transaction History" && (
                        <Box
                          sx={{
                            //maxHeight: editdetails ? "630px" : "850px",
                            height: "100%",
                            display: "flex",
                            gap: "20px",
                            flexDirection: "column",
                          }}
                        >
                          {/* <Box sx={{minHeight:"48px",display:"flex",alignItems:"center",justifyContent:"space-between",width:"100%"}}>
                              <Box sx={{display:"flex",alignItems:"center",gap:"20px"}}>
                                  <Box sx={{minWidth:"160px",height:"32px",gap:"15px",display:"flex",alignItems:"flex-end",paddingRight:"20px",borderRight:"1px solid #E2E8F0"}}>
                                  <Typography sx={{fontFamily:"inter",fontWeight:"600",fontSize:"24px",lineHeight:"32px"}}>{memberName}</Typography>
                              </Box>
                              <Box sx={{Width:"347px",height:"32px",gap:"15px",display:"flex",alignItems:"flex-end"}}>
                                  <Typography sx={{fontFamily:"inter",fontWeight:"400",fontSize:"16px",lineHeight:"24px",color:"#64748B"}}>Member No: {memberNo}</Typography>
                              </Box>
                              </Box>
                          </Box> */}
                          <MemberTransaction key={"Enter"} />
                        </Box>
                      )}
                      {active == "Nominee Information" && (
                        <Box
                          sx={{
                            height: "100%",
                            display: "flex",
                            gap: "20px",
                            flexDirection: "column",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "12px",
                            }}
                          >
                            <Typography
                              sx={{
                                fontFamily: "inter",
                                fontWeight: "500",
                                fontSize: "18px",
                                lineHeight: "28px",
                                color: "#64748B",
                                paddingLeft: "5px",
                              }}
                            >
                              Nominee Information
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                gap: "10px",
                                flexDirection: "column",
                                paddingLeft: "5px",
                              }}
                            >
                              {/* <BoxLoop count={nomineeCount}/> */}
                              {inputs.map((input, index) => (
                                <Box key={index} sx={{ display: "flex", gap: "10px" }}>
                                  {/* {addnominee && <Box sx={{display:"flex",flexDirection:"column",gap:"8px"}}>
                                                      <Typography sx={{ alignSelf: "stretch", width: "250px", fontFamily: "inter", fontSize: "16px", fontStyle: "normal", fontWeight: "400", lineHeight: "24px" ,color:"#101010"}}>Nominee Name<Typography component="span" sx={{color:"red"}}>*</Typography></Typography>
                                                      <MuiInput
                                                          label="Member No" variant="outlined"
                                                          required
                                                          disabled={ searchMemberStatus && !editdetails }
                                                          name = "nomineename"
                                                          value={nommid}
                                                          onChange={(event) => setNommind(event.target.value)}
                                                          onKeyDown={(event)=> handlenomEnter(event)}
                                                          style={{width: "100%", backgroundColor:"#FFF", fontSize:"14px" ,color:searchMemberStatus && !editdetails?"#242424":"#101010"}}
                                                      />
                                                  </Box>} */}
                                  <Typography sx={{ marginTop: '6px' }}>{index + 1}</Typography>
                                  
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "8px",
                                    }}
                                  >
                                    {/* <Typography sx={{ alignSelf: "stretch", width: "250px", fontFamily: "inter", fontSize: "16px", fontStyle: "normal", fontWeight: "400", lineHeight: "24px" ,color:"#101010"}}>Nominee Name<Typography component="span" sx={{color:"red"}}>*</Typography></Typography> */}
                                    <MuiInput
                                      label="Nominee Name"
                                      variant="outlined"
                                      required={true}
                                      disabled={searchMemberStatus && !editdetails}
                                      name="nomineename"
                                      value={input.nomineename}
                                      onChange={(event) =>
                                        handleInputChangeNominees(index, event)
                                      }
                                      sx={{
                                        width: "750px",
                                        backgroundColor: "#FFF",
                                        fontSize: "14px",
                                        color:
                                          searchMemberStatus && !editdetails
                                            ? "#242424"
                                            : "#101010",
                                      }}
                                    />
                                    {nomnamerror !== "" && (
                                      <Typography
                                        sx={{
                                          alignSelf: "stretch",
                                          fontFamily: "inter",
                                          fontSize: "16px",
                                          fontStyle: "normal",
                                          fontWeight: "400",
                                          lineHeight: "24px",
                                          color: "red",
                                        }}
                                      >
                                        {nomnamerror}
                                      </Typography>
                                    )}
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "8px",
                                    }}
                                  >
                                    {/* <Typography sx={{ alignSelf: "stretch", width: "250px", fontFamily: "inter", fontSize: "16px", fontStyle: "normal", fontWeight: "400", lineHeight: "24px" ,color:"#101010"}}>Nominee MyKAD<Typography component="span" sx={{color:"red"}}>*</Typography></Typography> */}
                                    <MuiInput
                                      label="Nominee MyKAD"
                                      variant="outlined"
                                      required={true}
                                      disabled={searchMemberStatus && !editdetails}
                                      mask="999999-99-9999"
                                      name="nomineeicno"
                                      value={input.nomineeicno}
                                      onChange={(event) =>
                                        handleInputChangeNominees(index, event)
                                      }
                                      sx={{
                                        width: "180px",
                                        backgroundColor: "#FFF",
                                        fontSize: "14px",
                                        color:
                                          searchMemberStatus && !editdetails
                                            ? "#242424"
                                            : "#101010",
                                      }}
                                    />
                                    {nomicerror !== "" && (
                                      <Typography
                                        sx={{
                                          alignSelf: "stretch",
                                          fontFamily: "inter",
                                          fontSize: "16px",
                                          fontStyle: "normal",
                                          fontWeight: "400",
                                          lineHeight: "24px",
                                          color: "red",
                                        }}
                                      >
                                        {nomicerror}
                                      </Typography>
                                    )}
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "8px",
                                    }}
                                  >
                                    {/* <Typography sx={{ alignSelf: "stretch", width: "250px", fontFamily: "inter", fontSize: "16px", fontStyle: "normal", fontWeight: "400", lineHeight: "24px" ,color:"#101010"}}>Nominee Name<Typography component="span" sx={{color:"red"}}>*</Typography></Typography> */}
                                    <MuiInput
                                      label="Age"
                                      variant="outlined"
                                      required={true}
                                      disabled={searchMemberStatus && !editdetails}
                                      name="age"
                                      value={input?.age}
                                      onChange={(event) =>
                                        handleInputChangeNominees(index, event)
                                      }
                                      sx={{
                                        width: "65px",
                                        backgroundColor: "#FFF",
                                        fontSize: "14px",
                                        color:
                                          searchMemberStatus && !editdetails
                                            ? "#242424"
                                            : "#101010",
                                      }}
                                    />
                                    {nomnamerror !== "" && (
                                      <Typography
                                        sx={{
                                          alignSelf: "stretch",
                                          fontFamily: "inter",
                                          fontSize: "16px",
                                          fontStyle: "normal",
                                          fontWeight: "400",
                                          lineHeight: "24px",
                                          color: "red",
                                        }}
                                      >
                                        {nomnamerror}
                                      </Typography>
                                    )}
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "8px",
                                    }}
                                  >
                                    {/* <Typography sx={{ alignSelf: "stretch", width: "250px", fontFamily: "inter", fontSize: "16px", fontStyle: "normal", fontWeight: "400", lineHeight: "24px" ,color:"#101010"}}>Relationship<Typography component="span" sx={{color:"red"}}>*</Typography></Typography> */}
                                    <MuiInput
                                      label="Relationship"
                                      variant="outlined"
                                      required={true}
                                      disabled={searchMemberStatus && !editdetails}
                                      name="relationship"
                                      value={input.relationship}
                                      onChange={(event) =>
                                        handleInputChangeNominees(index, event)
                                      }
                                      sx={{
                                        width: "200px",
                                        backgroundColor: "#FFF",
                                        fontSize: "14px",
                                        color:
                                          searchMemberStatus && !editdetails
                                            ? "#242424"
                                            : "#101010",
                                      }}
                                    />
                                    {/* <MuiAutocomplete
                                      label="Relationship"
                                      variant="outlined"
                                      required={true}
                                      disabled={searchMemberStatus && !editdetails}
                                      name="relationship"
                                      value={input.relationship}
                                      onChange={(event, newValue) =>
                                        handleRelationshipFilterChange(index, event, newValue)
                                      }
                                      options={relationshipArray.map(option => option.code).sort()} // Use the 'code' for value and 'name' for label
                                      getOptionLabel={(option) =>
                                        relationshipArray.find((item) => item.code === option)?.name || ''
                                      }
                                      // label="Relationship"
                                      autoCompleteStyle={{ width: '200px' }}
                                      sx={{
                                        width: '200px',
                                        backgroundColor: '#FFF',
                                        fontSize: '14px',
                                        color: searchMemberStatus && !editdetails ? '#242424' : '#101010',
                                      }}
                                    />*/ } 
                                    {relError !== "" && (
                                      <Typography
                                        sx={{
                                          alignSelf: "stretch",
                                          fontFamily: "inter",
                                          fontSize: "16px",
                                          fontStyle: "normal",
                                          fontWeight: "400",
                                          lineHeight: "24px",
                                          color: "red",
                                        }}
                                      >
                                        {relError}
                                      </Typography>
                                    )}
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "8px",
                                      width: "100%",
                                    }}
                                  >
                                    
                                    {/* <Box
                                      sx={{
                                        display: "flex",
                                        width: "90%",
                                        flexDirection: "row",
                                      }}
                                    > */}
                                      <MuiInput
                                        label="% of share"
                                        variant="outlined"
                                        required={true}
                                        disabled={searchMemberStatus && !editdetails}
                                        name="percentage"
                                        value={input.percentage}
                                        onChange={(event) =>
                                          handleInputChangeNominees(index, event)
                                        }
                                        InputProps={{
                                          endAdornment: (input.percentage) && (
                                            <InputAdornment position="end">%</InputAdornment>
                                          ),
                                        }}
                                        // InputProps={{ // Pass your custom InputProps here
                                        //   endAdornment: (
                                        //     <InputAdornment position="end">%</InputAdornment>
                                        //   ),
                                        // }}
                                        sx={{
                                          width: "120px",
                                          backgroundColor: "#FFF",
                                          fontSize: "14px",
                                          color:
                                            searchMemberStatus && !editdetails
                                              ? "#242424"
                                              : "#101010",
                                        }}
                                      />
                                      {/* <MuiInput
                                        value="%"
                                        variant="outlined"
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                        sx={{
                                          width: "45px",
                                          backgroundColor: "#FFF",
                                          fontSize: "14px",
                                          color:
                                            searchMemberStatus && !editdetails
                                              ? "#242424"
                                              : "#101010",
                                        }}
                                      /> */}
                                    {/* </Box> */}
                                    {perError !== "" && (
                                      <Typography
                                        sx={{
                                          alignSelf: "stretch",
                                          fontFamily: "inter",
                                          fontSize: "16px",
                                          fontStyle: "normal",
                                          fontWeight: "400",
                                          lineHeight: "24px",
                                          color: "red",
                                        }}
                                      >
                                        {perError}
                                      </Typography>
                                    )}
                                  </Box>
                                  {/* <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                          }}
                        >
                          <MuiInput
                            label="Age"
                            variant="outlined"
                            disabled={searchMemberStatus && !editdetails}
                            name="age"
                            value={age}
                            onChange={(event) =>
                              handleInputChangeNominees(index, event)
                            }
                            sx={{
                              width: "100%",
                              backgroundColor: "#FFF",
                              fontSize: "14px",
                              color:
                                searchMemberStatus && !editdetails
                                  ? "#242424"
                                  : "#101010",
                            }}
                          /> 
                          {perError !== "" && (
                            <Typography
                              sx={{
                                alignSelf: "stretch",
                                fontFamily: "inter",
                                fontSize: "16px",
                                fontStyle: "normal",
                                fontWeight: "400",
                                lineHeight: "24px",
                                color: "red",
                              }}
                            >
                              {perError}
                            </Typography>
                          )}
                        </Box> */}

                                  <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <IconButton
                                      disabled={searchMemberStatus && !editdetails}
                                      onClick={(e) => handleRemoveNominee(e, index)}
                                    >
                                      <CloseIcon sx={{ color: "red" }} />
                                    </IconButton>
                                  </Box>

                                </Box>
                              ))}
                              {nomineeError !== "" &&
                                <Typography
                                  sx={{
                                    alignSelf: "stretch",
                                    fontFamily: "inter",
                                    fontSize: "16px",
                                    fontStyle: "normal",
                                    fontWeight: "400",
                                    lineHeight: "8px",
                                    color: "red",
                                  }}
                                >
                                  {nomineeError}
                                </Typography>
                              }
                              <button
                                disabled={searchMemberStatus && !editdetails}
                                style={{
                                  padding: "8px 12px",
                                  borderRadius: "4px",
                                  border: "none",
                                  width: "180px",
                                  background: "#E2E8F0",
                                  display: "flex",
                                  gap: "15px",
                                  cursor: "pointer",
                                }}
                                onClick={(e) => handleAddMoreNominee(e)}
                              >
                                <AddIcon sx={{ color: "#64748B" }} />{" "}
                                <Typography
                                  sx={{
                                    alignSelf: "stretch",
                                    fontFamily: "inter",
                                    fontSize: "16px",
                                    fontStyle: "normal",
                                    fontWeight: "400",
                                    lineHeight: "24px",
                                    color: "#64748B",
                                  }}
                                >
                                  Add Nominee
                                </Typography>
                              </button>
                            </Box>
                          </Box>
                        </Box>
                      )}
                      {active == "Certificate Details" && <>
                        <Box>
                          <FormLabel component="legend" sx={{ fontWeight: "700" }}>Share Certificate Details</FormLabel>
                          <DataTable value={shareCertList} rows={5} style={{ backgroundColor: "#F1F5F9", height: shareCertList.length > 0 ? "220px" : "100%", fontSize: "12px" }} scrollable scrollHeight="220px" columnfinalMembersizeMode="expand" >
                            {shareCertColumnVisible.filter(col => col.visible).map((col, ind) => <Column className="custom-column-style" style={col.style} key={ind} field={col.field} filterElement={col.filterElement} header={col.header} sortable={col.sortable} body={col.body} filter={col.filter} alignFrozen="left" dataType={col.datatype} filterField={col.filterField} filterPlaceholder={col.filterPlaceholder} frozen={col.frozen} />)}
                          </DataTable>
                        </Box>
                      </>}
                      {active == "Guarantor Details" && <>
                        <Box>
                          <DataTable value={loanList} rows={5} style={{ backgroundColor: "#F1F5F9", height: loanList.length > 0 ? "220px" : "100%", fontSize: "12px" }} scrollable scrollHeight="220px" columnfinalMembersizeMode="expand" >
                            {ColumnVisible.filter(col => col.visible).map((col, ind) => <Column key={ind} field={col.field} filterElement={col.filterElement} header={col.header} sortable={col.sortable} body={col.body} filter={col.filter} alignFrozen="left" dataType={col.datatype} filterField={col.filterField} filterPlaceholder={col.filterPlaceholder} frozen={col.frozen} />)}
                          </DataTable>
                        </Box>
                        <Box>
                          <FormLabel component="legend" sx={{ fontWeight: "700" }}>Guarantor For the Loans Above</FormLabel>
                          <DataTable value={guarantorList} rows={5} style={{ backgroundColor: "#F1F5F9", height: guarantorList.length > 0 ? "220px" : "100%", fontSize: "12px" }} scrollable scrollHeight="220px" columnfinalMembersizeMode="expand" >
                            {GuarantorColumnVisible.filter(col => col.visible).map((col, ind) => <Column className="custom-column-style" style={col.style} key={ind} field={col.field} filterElement={col.filterElement} header={col.header} sortable={col.sortable} body={col.body} filter={col.filter} alignFrozen="left" dataType={col.datatype} filterField={col.filterField} filterPlaceholder={col.filterPlaceholder} frozen={col.frozen} />)}
                          </DataTable>
                        </Box>
                        <Box>
                          <FormLabel component="legend" sx={{ fontWeight: "700" }}>Guarantor For the Following Members[s]</FormLabel>
                          <DataTable value={guarantorForList} rows={5} style={{ backgroundColor: "#F1F5F9", height: guarantorForList.length > 0 ? "220px" : "100%", fontSize: "12px" }} scrollable scrollHeight="220px" columnfinalMembersizeMode="expand" >
                            {mgColumnVisible.filter(col => col.visible).map((col, ind) => <Column className="custom-column-style" style={col.style} key={ind} field={col.field} filterElement={col.filterElement} header={col.header} sortable={col.sortable} body={col.body} filter={col.filter} alignFrozen="left" dataType={col.datatype} filterField={col.filterField} filterPlaceholder={col.filterPlaceholder} frozen={col.frozen} />)}
                          </DataTable>
                        </Box>
                      </>}


                      <Box>
                        {editdetails == true && (active == "Member Profile" ||
                          active == "Nominee Information") ? (
                          <Box sx={{ display: "flex", gap: "20px", float:"right", margin:"10px" }}>
                            {/* {memberSuccess!==""&&<Typography sx={{ alignSelf: "stretch",  fontFamily: "inter", fontSize: "16px", fontStyle: "normal", fontWeight: "400", lineHeight: "24px",color:"green",display:"flex",alignItems:"center" }} startIcon={<CheckOutlined/>}>{memberSuccess}</Typography>} */}

                            <Button
                              fullWidth
                              variant="contained"
                              sx={{
                                width: "165px",
                                height: "36px",
                                borderRadius: "4px",
                                display: "flex",
                                gap: "6px",
                                justifyContent: "flex-start",
                                background: "#E7EFE9",
                              }}
                              onClick={(e) => {
                                // checkForEmptyObjects(inputs) 
                                if (checkForEmptyObjects(inputs, "edit") !== null) {
                                  updateMember(e)
                                }
                                // console.log(checkForEmptyObjects(inputs, "edit"))
                              }}
                            >
                              <FileUploadIcon />
                              <Typography
                                sx={{
                                  fontFamily: "inter",
                                  fontSize: "16px",
                                  fontWeight: "400",
                                  lineHeight: "24px",
                                  textTransform: "none",
                                }}
                              >
                                Update Profile
                              </Typography>
                            </Button>

                            <Button
                              fullWidth
                              variant="outlined"
                              color="primary"
                              sx={{
                                width: "165px",
                                height: "36px",
                                borderRadius: "4px",
                                display: "flex",
                              }}
                              onClick={() => setEditDetails(!editdetails)}
                            >
                              <Typography
                                sx={{
                                  fontFamily: "inter",
                                  fontSize: "16px",
                                  fontWeight: "400",
                                  lineHeight: "24px",
                                  textTransform: "none",
                                }}
                              >
                                Clear
                              </Typography>
                            </Button>
                            

                          </Box>
                        ) : active == "Member Profile" || active == "Nominee Information" ? (
                          <Box sx={{ display: "flex", gap: "20px", float:"right", margin:"10px" }}>
                            {/* {response?.response=="Registration Successful!" && <Typography sx={{marginTop:"20px", alignSelf: "stretch", width: "200px", fontFamily: "inter", fontSize: "16px", fontStyle: "normal", fontWeight: "400", lineHeight: "24px",color:"var(--Light-Utility-Primary, #E7EFE9)" ,display:"flex",alignItems:"center",width:"100%"}} startIcon={<CheckOutlined/>}>Member added successfully</Typography>} */}
                          
                            {searchMemberStatus && (
                              <Box
                                sx={{
                                  cursor:"pointer",
                                  gap: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                  border:"1px solid red",
                                  padding:"0px 16px"
                                }}
                                onClick={() => setEditDetails(!editdetails)}
                              >
                                <Typography
                                  sx={{
                                    fontFamily: "inter",
                                    fontWeight: "400",
                                    fontSize: "16px",
                                    lineHeight: "24px",
                                    color: editdetails ? "green" : "red",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <EditNoteIcon />
                                  Edit Details
                                </Typography>
                              </Box>
                            )}
                            {
                              !searchMemberStatus && (
                              <MuiButton
                                variant="contained"
                                onClick={
                                  searchMemberStatus
                                    ? () => clearAllStates()
                                    : (e) => handleSignup(e)}
                                value="Save"
                              />
                              )
                            }
                            <MuiButton
                              variant="outlined"
                              onClick={() => clearAllStates()}
                              value="Clear"
                            />
                          </Box>
                        ) : (
                          active == "Transaction History" && (
                            <Box sx={{ display: "flex", gap: "10px", float:"right", margin:"10px" }}>
                              {/* {transType!=="loan_transactions" && <FormGroup>
                                    <FormControlLabel 
                                        control={<Checkbox color="success" />} 
                                        label="With Notes"
                                        sx={{ "& .MuiSvgIcon-root":  
                                            { fontSize: 28 } }}
                                        onChange={handleChange}
                                    /> 
                                    </FormGroup>} */}
                              {/* <Button
                  type="submit"
                  variant="contained"
                  disabled={
                    transType == "loan_transactions" && loansel.length == 0
                      ? true
                      : false
                  }
                  onClick={handleFetchAndPrintReceipt}
                  sx={{
                    width: "250px",
                    display: "flex",
                    flexShrink: 0,
                    fontSize: "16px",
                    padding: "12px",
                    height: "36px",
                  }} // Adjust width as needed
                >
                  Print Member Ledger
                </Button> */}
                            </Box>
                          )
                        )}
                        {active == "Transaction History" && (translist.includes(transType)) && (
                          <Box sx={{ display: "flex", gap: "10px", float:"right", margin:"10px 10px 0px 0px" }}>
                            {/* {transType!=="loan_transactions" && <FormGroup>
                                    <FormControlLabel 
                                        control={<Checkbox color="success" />} 
                                        label="With Notes"
                                        sx={{ "& .MuiSvgIcon-root":  
                                            { fontSize: 28 } }}
                                        onChange={handleChange}
                                    /> 
                                    </FormGroup>} */}
                            <Button
                              type="submit"
                              variant="contained"
                              disabled={
                                transType == "loan_transactions" && loansel.length == 0
                                  ? true
                                  : false
                              }
                              onClick={handleFetchAndPrintReceipt}
                              sx={{
                                width: "250px",
                                display: "flex",
                                flexShrink: 0,
                                fontSize: "16px",
                                padding: "12px",
                                height: "44px",
                              }} // Adjust width as needed
                            >
                              Print Member Ledger
                            </Button>
                          </Box>
                        )}
                      </Box>
                      <Dialog
                        visible={searchbulkdialogopen}
                        style={{ width: "600px", padding: "20px" }}
                        onHide={() => setSearchBulkDialogopen(false)}
                      >
                        <Box sx={{ padding: "20px" }}>
                          <Typography
                            sx={{
                              fontFamily: "inter",
                              fontWeight: "500",
                              fontSize: "18px",
                              lineHeight: "28px",
                              color: "#64748B",
                            }}
                          >
                            Duplicate Found
                          </Typography>
                          <Typography
                            sx={{
                              fontFamily: "inter",
                              fontWeight: "400",
                              fontSize: "16px",
                              lineHeight: "24px",
                              color: "black",
                            }}
                          >
                            IC No: {memberNric.newicno} Already Exist
                          </Typography>
                          <Typography
                            sx={{
                              fontFamily: "inter",
                              fontWeight: "400",
                              fontSize: "16px",
                              lineHeight: "24px",
                              color: "#64748B",
                            }}
                          >
                            MNo: {memberNric.memberid}
                          </Typography>
                          <Typography
                            sx={{
                              fontFamily: "inter",
                              fontWeight: "400",
                              fontSize: "16px",
                              lineHeight: "24px",
                              color: "#64748B",
                            }}
                          >
                            Member Name: {memberNric.membername}
                          </Typography>
                          <Typography
                            sx={{
                              fontFamily: "inter",
                              fontWeight: "400",
                              fontSize: "16px",
                              lineHeight: "24px",
                              color: "#64748B",
                            }}
                          >
                            Member Nric(New): {memberNric.newicno}{" "}
                          </Typography>
                        </Box>
                      </Dialog>

                      <Dialog
                        visible={nomineeModel}
                        style={{ width: "600px" }}
                        onHide={() => setNomineeModel(false)}>
                        <Box sx={{ padding: "20px" }}>


                          <Typography
                            sx={{
                              alignSelf: "stretch",
                              width: "100%",
                              fontFamily: "inter",
                              fontSize: "16px",
                              fontStyle: "inter",
                              fontWeight: "400",
                              lineHeight: "24px",
                              color: "#288d2c",
                            }}
                          >
                            The Nominee field is empty. Do you wish to proceed?
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              marginTop: "8px"
                              // justifyContent: "space-between",
                            }}
                          >
                            <Button
                              type="submit"
                              variant="contained"
                              onClick={(e) => {
                                if (nomineeModelType === "create") {
                                  handleSignup(e, true);
                                } else {
                                  console.log("inside else")
                                  updateMember(e);
                                }
                              }}
                              sx={{
                                width: "50px",
                                display: "flex",
                                flexShrink: 0,
                                fontSize: "16px",
                                padding: "12px",
                                height: "36px",
                              }} // Adjust width as needed
                            >
                              Yes
                            </Button>
                            <Button
                              variant="contained"
                              onClick={() => setNomineeModel(false)}
                              sx={{
                                width: "75px",
                                display: "flex",
                                flexShrink: 0,
                                fontSize: "16px",
                                padding: "12px",
                                height: "36px",
                                marginLeft: "16px"
                              }} // Adjust width as needed
                            >
                              No
                            </Button>
                          </Box>
                        </Box>

                      </Dialog>

                    </Box>
                  </Box>
                )}
              </Grid>
            </Box>
          </Box>
        )}
      
    </Box>
  );
}